import { TitleCasePipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, HostListener, OnDestroy, OnInit, QueryList, ViewChild, ViewChildren, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';
import _ from 'lodash';
import moment from 'moment';
import { empty, Subscription } from 'rxjs';
import { DataRetentionPolicyComponent } from 'src/app/layout/data-retention-policy/data-retention-policy.component';
import { ReservationService } from 'src/app/layout/reservation.service';
import { PopupMessageComponent } from 'src/app/shared/components/popup-message/popup-message.component';
import { ActivityTabs, buttonTypes, componentName, ComponentTypes } from 'src/app/shared/constants/commonenums';
import { DynamicFormComponent } from 'src/app/shared/dynamicform/dynamic-form/dynamic-form.component';
import { ButtonValue, FieldConfig } from 'src/app/shared/dynamicform/models/common-models';
import { ComponentDetails } from 'src/app/shared/dynamicform/models/popup.interface';
import { DynamicFormService } from 'src/app/shared/dynamicform/service/dynamic-form.service';
import { CustomFieldsDTO, PartyNoteType, PaymentGateways, PaymentStates, RegisterReservationAttemptResponseDTO, SecondaryContactDTO, PartyType, FinancialEffectForUpdatedReservationDTO, ContactDTO } from 'src/app/shared/Models/PartyModels';
import { SlotLockResultDTO } from 'src/app/shared/Models/SlotLockModels';
import { ConfirmationVia, CountryDTO, operationType, PolicyDataType } from 'src/app/shared/Models/WidgetSettingsModels';
import { PopupService } from 'src/app/shared/services/popup.service';
import { Utilities } from 'src/app/shared/utilities/utilities';
import { environment } from 'src/environments/environment';
// import { isArray } from 'util';
import { BookingActivity, BookingBehavior } from '../../Models/SessionBookingDTO';
import { GuestService } from '../../services/guest.service';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthRefundPopupComponent } from '../auth-refund-popup/auth-refund-popup.component';
import { ValidationMessageType } from '../../Models/ResultModels';
import { CurrencyDecimalFormatter } from '../../pipes/currency-decimal.pipe';

@Component({
  selector: 'app-guest-data',
  templateUrl: './guest-data.component.html',
  styleUrls: ['./guest-data.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.Default
})
export class GuestDataComponent extends Utilities implements OnInit, OnDestroy {
  guestInfoConfig: FieldConfig[];
  guestInfoConfigSecondary: FieldConfig[];
  guestConfig: FieldConfig[];
  confirmButton: ButtonValue;
  previousButton: ButtonValue;
  addToButton: ButtonValue;
  editButton: ButtonValue;
  additionalGuestBtn: ButtonValue;
  backButton: ButtonValue;
  SaveGuestbtn: ButtonValue;
  guestDetailsForm: FormGroup;
  guestDataPrimary = [{ name: 'primaryGuest', isNew: false }];
  guestDataSecondary = [{ name: 'secondaryGuest1', isNew: true }];
  guestData = [];
  @ViewChildren('form') components: QueryList<DynamicFormComponent>;
  @ViewChildren('memberForm') memberForm: QueryList<DynamicFormComponent>;
  @ViewChild('d') primaryGuest: DynamicFormComponent;
  partySize = 5;
  subscriptions: Subscription = new Subscription();
  partyDetails: any;
  lockResult: SlotLockResultDTO;
  deleteSecondaryGuestPopUpRef: MatDialogRef<any>;
  paymentData: RegisterReservationAttemptResponseDTO;
  urlSafe: SafeResourceUrl;
  waiverFormTrancationId = null;
  isUserAllowedToclickConfirm = false;
  stopListening: Function;
  showIframe = false;
  IframeURL = '';
  waiverFormTransactionId = '';
  countryCodes: CountryDTO[] = [];
  selectedCountryId: Number;
  noShowfeeMessage = '';
  noShowfee: Number;
  activityPayment: any;
  paymentMessage = '';
  notesFormGroup: any;
  dataRetentionPolicyExisting = false;
  primaryGuestPhone = '';
  primaryGuestEmail = '';
  dataRetentionPolicyDialogRef: MatDialogRef<any>;
  financialPopUpRef: MatDialogRef<any>;
  AuthrefundPopupRef: MatDialogRef<any>
  popUpMessage = '';
  noShowPolicyTitle = '';
  ratePlanAmountInfo: number;
  specialMealAmountInfo: number;
  paymentAmountInfo: number;
  operationType = operationType;
  freeTextIdList = [];
  secondaryGuestTobeDeletedIndex: number;
  ratePlan: any;
  restaurantName: string;
  TotalAmount: any = 0;
  isSplitPayment: boolean;
  PartyId: number;
  PaymentGateway: number;
  RefundData: any;
  isAuthRefund: boolean;
  financialData: FinancialEffectForUpdatedReservationDTO;
  guestFieldValidation: boolean = true;
  cancellationPolicy: string = "";
  membershipConfig: FieldConfig[];
  bookBtn: ButtonValue;
  waiverForm = false;
  cartEvents: { isAdd?: boolean, isUpdate?: boolean };
  constructor(private ts: TranslateService, private dfs: DynamicFormService, private fb: FormBuilder, public rs: ReservationService, public sanitizer: DomSanitizer, private ps: PopupService, public dialog: MatDialog, public titleCasePipe: TitleCasePipe, private currencyDecimalFormatter: CurrencyDecimalFormatter,
    public gs: GuestService, private route: ActivatedRoute) {
    super(dialog)
    this.subscriptions.add(this.gs.editPartyData$.subscribe(data => {
      if (data) {
        this.partyDetails = data;
        this.gs.primaryContact = data.Contact;
      } else {
        this.partyDetails = null;
        this.gs.primaryContact = {} as ContactDTO;
      }
    }));
    this.subscriptions.add(this.gs.TimerOff$.subscribe(data => {
      if (!data) {
        if (this.financialPopUpRef) {
          this.financialPopUpRef.close();
        }
        if (this.AuthrefundPopupRef) {
          this.AuthrefundPopupRef.close();
        }
      }
    }));
  }

  getCancellationPolicy(activityId) {
    return this.gs.restaurantWidgetSettings$.value.AvailableSpecialMeals.filter(x => x.Id == activityId)[0]?.CancellationPolicy;
  }
  ngOnInit(): void {
    this.restaurantName = this.route.snapshot.params.restaurantName;
    this.guestDetailsForm = this.fb.group({})
    this.countryCodes = this.gs.countriesList;
    this.createGuestConfig();
    this.addCategoryPreferencesNotes();
    this.cancellationPolicy = this.getCancellationPolicy(this.gs.SaveBookingObj.SpecialMealId);
    let guestConfigCopy = _.cloneDeep(this.guestConfig);
    if (this.gs.additionalGuestPage && this.gs.operation != operationType.edit) {
      this.guestData = _.cloneDeep(this.guestDataSecondary)
      this.guestInfoConfig = _.cloneDeep(this.guestConfig)
    }
    else if (!this.gs.additionalGuestPage && this.gs.operation == operationType.edit) {
      this.guestData = _.cloneDeep(this.guestDataPrimary);
      if (!this.gs.secondaryContactList) {
        this.gs.secondaryContactList = this.gs.editPartyData$.value.SecondaryContacts;
      }
      let partySize = this.gs.operation == operationType.edit && this.gs.secondaryContactList ? this.gs.secondaryContactList.length : 0;//this.gs.reservationFormGroup.controls.guestDetailsForm.get('secondaryContactList').value.length
      while (partySize != 0) {
        this.guestData.push({ name: this.ts.instant('secondaryGuest') + (this.guestData.length + 1), isNew: false });
        partySize--;
      }
      this.guestInfoConfig = _.cloneDeep(this.guestConfig);
      this.addCustomGuestFields();
      this.addRequiredCustomTermsAndConditions();
      this.guestInfoConfigSecondary = _.cloneDeep(this.guestConfig)
      this.guestInfoConfigSecondary[0].value = '';
      this.guestInfoConfigSecondary[1].value = '';
      this.guestInfoConfigSecondary[2].disableSelect = true;
    }
    else {
      this.guestData = _.cloneDeep(this.guestDataPrimary)
      this.guestInfoConfig = _.cloneDeep(this.guestConfig)
    }

    if (this.countryCodes && this.countryCodes.length > 0) {
      let countrySelected = Utilities.getDefaultCountry(this.countryCodes, this.gs.restaurantWidgetSettings$.value.Country);
      this.guestInfoConfig[2].options = [];
      this.countryCodes.forEach(element => {
        this.guestInfoConfig[2].options.push({ id: element.Id, value: element.CountryPhoneCode + '  (' + element.Name + ' )' });
      })
      if (this.gs.primaryContact) {
        const selectedCountryCode = this.countryCodes.filter((country) => {
          return country.Id === this.gs.primaryContact.CountryId;
        })[0];
        if (selectedCountryCode) {
          this.gs.selectedCountryId = selectedCountryCode.Id;
          this.dfs.selectedCountryCode = selectedCountryCode.CountryPhoneCode;
          this.dfs.selectedCountryId = selectedCountryCode.Id;
        }
      }
      this.guestInfoConfig[2].value = this.gs.selectedCountryId ? this.gs.selectedCountryId : countrySelected.Id;
      if (this.partyDetails && this.partyDetails.Contact.Mobile) {
        this.guestInfoConfig[2].value = this.partyDetails.Contact.Mobile;
      }
      if (operationType.edit == this.gs.operation && this.guestInfoConfigSecondary) {
        this.guestInfoConfigSecondary[2].options = _.cloneDeep(this.guestInfoConfig[2].options);
        this.guestInfoConfigSecondary[2].value = _.cloneDeep(this.guestInfoConfig[2].value);
      }
      this.dfs.selectedCountryCode = this.dfs.selectedCountryCode ? this.dfs.selectedCountryCode : countrySelected.CountryPhoneCode;
    }
    this.createActionButtons();

    if (!this.gs.additionalGuestPage) {
      if (this.gs.operation != operationType.edit) {
        this.addCustomGuestFields();
        this.addRequiredCustomTermsAndConditions();
      }
      this.gs.operation == operationType.edit ? this.RegisterReservationAttempt(true) : this.GetPreliminaryReservationInformation();
    }
    else {
      this.isUserAllowedToclickConfirm = true;
    }

    this.subscriptions.add(this.ps.actionEnabled$.subscribe(from => {
      if (from == ComponentTypes.dataRetentionPolicy) {
        if (this.dataRetentionPolicyDialogRef) {
          this.dataRetentionPolicyDialogRef.close();
        }
      }
      else if (from == ComponentTypes.deleteSecondaryGuest) {
        this.deleteSecondaryGuestConfirmed();
        this.deleteSecondaryGuestPopUpRef.close();
      }
      else if (from == ComponentTypes.financialEffectCalculation) {
        this.financialPopUpRef.close();
        if (this.RefundData) {
          this.showAuthRefundPopup();
        }
      }
      else if (from == ComponentTypes.AuthRefundPopup) {
        this.AuthrefundPopupRef.close();
        this.isAuthRefund = true;
      }
    }));

    this.subscriptions.add(this.ps.cancelEnabled$.subscribe(from => {
      if (from == ComponentTypes.financialEffectCalculation || from == ComponentTypes.AuthRefundPopup) {
        this.goBackToReservation();
      }
      if (from == ComponentTypes.deleteSecondaryGuest) {
        this.deleteSecondaryGuestPopUpRef.close();
      }
    }));

    if (this.gs.additionalGuestPage) {
      setTimeout(() => this.subscribeMemberConfig(), 100)
    }

    this.subscriptions.add(
      this.gs.overlapBookingproceedEvent.subscribe(x=>{
        if(x.proceedOverlapBooking && !x.isOverlapErrorFromValidateCartApi) {
          this.reservationConfirm(true);
        } else if (x.proceedOverlapBooking && x.isOverlapErrorFromValidateCartApi) {
          if(this.cartEvents.isAdd) this.addtoCartDataSuccessHandler();
          else if(this.cartEvents.isUpdate) this.updateCartSuccessHandler();
        }
      })
    )
  }

  createGuestConfig() {
    this.membershipConfig = [{
      type: 'input',
      label: this.ts.instant('MembershipID'),
      name: 'MembershipId',
      inputType: 'text',
      class: 'guest-details__first-name',
      showErrorText: true,
      appearance: true,
      isFormArray: false,
      validation: [Validators.required],
    }];
    this.guestConfig = [
      {
        type: 'input',
        label: this.ts.instant('firstName'),
        name: 'firstName',
        inputType: 'text',
        class: 'guest-data__first-name',
        showErrorText: true,
        appearance: true,
        isFormArray: false,
        isMandatory: true,
        errorMessage: this.ts.instant('firstNameRequired'),
        validation: [Validators.required],
        value: this.partyDetails ? this.partyDetails.Contact.FirstName ? this.partyDetails.Contact.FirstName : this.partyDetails.Contact.FName ? this.partyDetails.Contact.FName : '' : ''
      },
      {
        type: 'input',
        label: this.ts.instant('lastName'),
        name: 'lastName',
        inputType: 'text',
        class: 'guest-data__last-name',
        showErrorText: true,
        appearance: true,
        isFormArray: false,
        isMandatory: true,
        errorMessage: this.ts.instant('lastNameRequired'),
        validation: [Validators.required],
        value: this.partyDetails ? this.partyDetails.Contact.LastName ? this.partyDetails.Contact.LastName : this.partyDetails.Contact.LName ? this.partyDetails.Contact.LName : '' : ''
      },
      {
        type: 'inputSelect',
        label: this.ts.instant('phone'),
        name: 'phone',
        inputType: 'text',
        placeholder: 'registerPinText',
        class: 'guest-data__phone',
        showErrorText: true,
        appearance: true,
        errorMessage: this.ts.instant('phoneRequired'),
        isFormArray: false,
        cellClick: this.countryCodeSelected.bind(this),
        isPhoneNumber: true, 
        isMandatory: true,
        validation: [Validators.required],
        disableSelect: this.gs.additionalGuestPage,
        value: this.partyDetails ? this.partyDetails.Contact.PhoneNumber ? this.partyDetails.Contact.PhoneNumber : this.partyDetails.Contact.Mobile ? this.partyDetails.Contact.Mobile : '' : ''

      },
      {
        type: 'input',
        label: this.ts.instant('email'),
        name: 'email',
        inputType: 'email',
        placeholder: 'registerPinText',
        class: 'guest-data__email',
        showErrorText: true,
        appearance: true,
        isFormArray: false,
        isMandatory: true,
        errorMessage: this.ts.instant('emailRequired'),
        validation: [Validators.required, Validators.email, Validators.pattern('^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\\.[A-Za-z]{2,4}$')],
        value: this.partyDetails ? this.partyDetails.Contact.EmailAddress ? this.partyDetails.Contact.EmailAddress : this.partyDetails.Contact.EmailList ? this.partyDetails.Contact.EmailList[0].EmailId : '' : ''
      }
    ];
  }

  createActionButtons() {
    this.confirmButton = {
      type: buttonTypes.confirmBtn,
      label: this.ts.instant('confirm'),
      customclass: 'guest-data__previous-btn',
      disbaledproperity: true
    };
    this.addToButton = {
      type: buttonTypes.confirmBtn,
      label: this.ts.instant('AddToCart'),
      customclass: 'guest-data__confirm-btn',
      disbaledproperity: true
    }
    this.bookBtn = {
      type: buttonTypes.confirmBtn,
      label: this.ts.instant('UpdateCart'),
      customclass: 'guest-data__previous-btn',
      disbaledproperity: false
    };
    this.editButton = {
      type: buttonTypes.confirmBtn,
      label: this.ts.instant('edit'),
      customclass: 'guest-data__confirm-btn',
      disbaledproperity: false
    };
    this.previousButton = {
      type: buttonTypes.cancelBtn,
      label: this.ts.instant('clearAll'),
      customclass: 'guest-data__previous-btn',
    };
    this.additionalGuestBtn = {
      type: buttonTypes.cancelBtn,
      label: this.ts.instant('guestDetails'),
      customclass: 'guest-data__additional-guest',
      icon: 'icon-add'
    };
    this.backButton = {
      type: buttonTypes.cancelBtn,
      label: this.ts.instant('previous'),
      customclass: 'guest-data__previous-btn',
    };
    this.SaveGuestbtn = {
      type: buttonTypes.confirmBtn,
      label: this.ts.instant('Save'),
      customclass: 'guest-data__previous-btn',
    };
  }

  addCategoryPreferencesNotes() {
    if (this.gs.restaurantWidgetSettings$.value.PreferencesCategories && this.gs.restaurantWidgetSettings$.value.PreferencesCategories.length > 0) {
      this.gs.restaurantWidgetSettings$.value.PreferencesCategories.filter(x => x.Text !== 'Reasons').forEach(category => {
        if (category.IncludeInWebReservation) {
          let predefinedNotes = [];
          let freeTextIdValue;
          category.SubCategories && category.SubCategories.length > 0 ? category.SubCategories.map(x => {
            if (x.PredefinedContactNote && x.PredefinedContactNote.length > 0) {
              x.PredefinedContactNote.forEach(note => {
                if (note.Text.toLowerCase() == "others") {
                  freeTextIdValue = note.Id;
                  this.freeTextIdList.push(freeTextIdValue);
                } else {
                  let predefinedContactNoteMappingList = note.PredefinedContactNotePropertyMapping.filter(x => x.PropertyId == this.gs.restaurantWidgetSettings$.value.RestaurantId).map(x => x.PredefinedContactNoteId);
                  if (predefinedContactNoteMappingList.find(x => x == note.Id)) { predefinedNotes.push(note) }
                }
              });
            }
          }) : [];
          if (predefinedNotes && predefinedNotes.length > 0) {
            let options = predefinedNotes.map(x => { return { id: x.Id, value: x.Text } });
            this.guestConfig.push({
              type: 'checkbox',
              placeholder: 'ds',
              value: false,
              name: 'preferences_' + category.Id.toString(),
              groupLabel: category.Text,
              options: options,
              isFormArray: true,
              class: 'guest-data__special-requests'
            })

            if (freeTextIdValue) {
              let freeTextValue = ''
              if (!this.gs.additionalGuestPage && this.gs.primaryContact && this.gs.primaryContact.Notes && this.gs.primaryContact.Notes.length > 0) {
                if (this.gs.primaryContact.Notes.filter(x => x.RelatedId == freeTextIdValue)[0]) {
                  freeTextValue = this.gs.primaryContact.Notes.filter(x => x.RelatedId == freeTextIdValue)[0].Text;
                }
              }
              this.guestConfig.push({
                type: 'textarea',
                name: freeTextIdValue.toString(),
                class: 'guest-data__special-notes',
                label: 'Others',
                appearance: true,
                isFormArray: false,
                value: ''
              })
            }
          }
        }

      });
    }
  }

  countryCodeSelected(eve) {
    const selectedCountryCode = this.countryCodes.filter((country) => {
      return country.Id === eve.value;
    })[0];
    this.gs.selectedCountryId = selectedCountryCode.Id;
    this.dfs.selectedCountryCode = selectedCountryCode.CountryPhoneCode;
    this.dfs.selectedCountryId = selectedCountryCode.Id;
    const phoneValue = this.components.first.form.get('phone').value;
    let phoneNumber: any;
    phoneNumber = this.dfs.onInputChange(phoneValue ? phoneValue : eve.value, false);
    if (this.components.first.form.get('phone').value && this.components.first.form.get('phone').value.length > 0) {
      this.components.first.form.get('phone').setValue(phoneNumber);
    }
    if (operationType.edit == this.gs.operation && this.guestInfoConfigSecondary) {
      this.guestInfoConfigSecondary[2].value = this.gs.selectedCountryId ? this.gs.selectedCountryId : selectedCountryCode.Id;
    }
    if (this.dfs.requiredPhoneNumberLength$) {
      const count = this.dfs.requiredPhoneNumberLength$;
      this.components.first.form.get('phone').setValidators([Validators.minLength(count), Validators.maxLength(count)]);
      this.guestDetailsForm.get('primaryGuest')['controls']['phone'].setValidators([Validators.minLength(count), Validators.maxLength(count)]);
      this.components.first.form.get('phone').updateValueAndValidity();
      this.guestDetailsForm.get('primaryGuest')['controls']['phone'].updateValueAndValidity();
      this.components.toArray().forEach((formData, index) => {
        if (index > 0) {
          //formData.form.controls.firstName.setValue(this.gs.reservationFormGroup.controls.guestDetailsForm.get('secondaryContactList').value[index - 1].FirstName)
          formData.form['controls']['phone'].setValidators([Validators.minLength(count), Validators.maxLength(count)]);
          if (formData.form.value.phone && formData.form.value.phone.length > 0) {
            let phoneValue = this.dfs.onInputChange(formData.form.value.phone, false);
            formData.form.controls.phone.setValue(phoneValue);
          }
          formData.form['controls']['phone'].updateValueAndValidity();
        }
      });
    }
  }

  addCustomGuestFields() {
    let promoCodeValue = '';
    if (this.gs.operation == operationType.edit && this.gs.editPartyData$.value.Notes && this.gs.editPartyData$.value.Notes.length > 0) {
      this.gs.editPartyData$.value.Notes.forEach(note => {
        if (note.Type == PartyNoteType.PromoCode && note.Text) {
          promoCodeValue = note.Text;
        }
      });
    }
    this.guestInfoConfig.push(
      {
        type: 'input',
        label: this.gs.restaurantWidgetSettings$.value.WidgetCustomization.PromoCodeLabel ? this.gs.restaurantWidgetSettings$.value.WidgetCustomization.PromoCodeLabel : this.ts.instant('promoCode'),
        value: promoCodeValue ? promoCodeValue : '',
        name: 'promocode',
        placeholder: this.gs.restaurantWidgetSettings$.value.WidgetCustomization.PromoCodeLabel ? this.gs.restaurantWidgetSettings$.value.WidgetCustomization.PromoCodeLabel : 'Promo Code',
        class: 'guest-data__promo-code',
        appearance: true,
        isFormArray: false,
      });


    if (this.gs.customGuestFields && this.gs.customGuestFields.CustomGuestField && this.gs.customGuestFields.CustomGuestField.length > 0) {
      this.gs.customGuestFields.CustomGuestField = _.sortBy(this.gs.customGuestFields.CustomGuestField, 'FieldType').reverse();
      this.gs.customGuestFields.CustomGuestField.forEach(field => {
        let fieldValue = ''
        if (this.gs.primaryContact && this.gs.primaryContact.ContactCustomFields && this.gs.primaryContact.ContactCustomFields.length > 0) {
          fieldValue = this.gs.primaryContact.ContactCustomFields.filter(x => x.CustomFieldId == field.Id)[0] ? this.gs.primaryContact.ContactCustomFields.filter(x => x.CustomFieldId == field.Id)[0].CustomFieldValue : '';
        }
        if (field.IsCustomGuestFieldVisible && field.AvailableForOnlineReservation) {
          if (field.FieldType == 'Text Field') {
            this.guestInfoConfig.push({
              type: 'input',
              placeholder: field.FieldName,
              value: fieldValue ? fieldValue : '',
              name: 'customGuestField_' + field.Id.toString(),
              class: 'guest-data__promo-code',
              isFormArray: false,
              appearance: true,
              label: field.FieldName,
              showErrorText: this.customFieldMandatory(field),
              errorMessage: this.customFieldErrorMessage(field),
              validation: this.customValidationRequired(field),
              isMandatory: this.customFieldMandatory(field),

            });
          }
          if (field.FieldType == 'Drop Down') {
            let Options = [];
            Options = field.FieldOptions.split(',').map(x => { return { id: x, value: x } });
            Options.splice(0, 0, { id: '', value: field.FieldName })
            this.guestInfoConfig.push({
              type: 'select',
              placeholder: field.FieldName,
              options: Options,
              value: fieldValue ? fieldValue : Options[0].id,
              name: 'customGuestField_' + field.Id.toString(),
              class: 'guest-data__promo-code',
              isFormArray: false,
              appearance: true,
              label: field.FieldName,
              showErrorText: this.customFieldMandatory(field),
              errorMessage: this.customFieldErrorMessage(field),
              validation: this.customValidationRequired(field),
              isMandatory: this.customFieldMandatory(field),
            });
          }
        }
      });
    }
  }
  customFieldErrorMessage(field) {
    if (this.customFieldMandatory(field)) {
      return field.FieldName + ' is required';
    } else {
      return '';
    }
  }
  customValidationRequired(field) {
    if (this.customFieldMandatory(field)) {
      return [Validators.required];
    } else {
      return [];
    }
  }

  customFieldMandatory(field) {
    if (field && this.gs.selectedSpecialMeal) {
      let validationField = this.gs.selectedSpecialMeal.customFieldValidation;
      if (validationField && validationField.length > 0) {
        let fieldIds = [];
        validationField.forEach(function (value) {
          fieldIds.push(value.CustomGuestFieldId);
        })
        if (fieldIds.includes(field.Id)) {
          return true;
        } else {
          return false;
        }
      }
    }
  }
  addRequiredCustomTermsAndConditions() {
    if (this.gs.operation != operationType.edit) {
      this.guestInfoConfig.push({
        type: 'checkbox',
        placeholder: this.getAgreeTermsAndConditionsText(),
        value: false,
        name: 'agreeTerms',
        class: 'guest-data__terms-and-conditions',
        isFormArray: false,
        validation: [Validators.requiredTrue],
        innerHTMLdata: true
      })
    }

    if (this.gs.restaurantWidgetSettings$.value.IsSmsReminderSupported) {
      if (this.gs.restaurantWidgetSettings$.value.WidgetCustomization.IsReservationReminderMandatory) {
        this.guestInfoConfig.push({
          type: 'checkbox',
          placeholder: 'SmsMessageReminderText',
          value: true,
          name: 'reservationBySMS',
          class: 'guest-data__reservation-by-sms',
          isFormArray: false,
          disabled: true
        });
      }
      else {
        this.guestInfoConfig.push({
          type: 'checkbox',
          placeholder: 'SmsMessageReminderText',
          value: false,
          name: 'reservationBySMS',
          class: 'guest-data__sms-reminder',
          isFormArray: false
        });
      }
    }
    this.guestInfoConfig.push({
      type: 'checkbox',
      placeholder: 'emailReminderText',
      value: false,
      name: 'reservationByEmail',
      class: 'guest-data__email-remainder',
      isFormArray: false
    });

    if (this.gs.operation != operationType.edit) {
      if (this.gs.restaurantWidgetSettings$.value.WidgetCustomization.CustomTermsOfService && this.gs.restaurantWidgetSettings$.value.WidgetCustomization.CustomTermsOfService.length > 0) {
        this.gs.restaurantWidgetSettings$.value.WidgetCustomization.CustomTermsOfService.forEach((customTerm, index) => {
          this.guestInfoConfig.push({
            type: 'checkbox',
            placeholder: customTerm,
            value: false,
            name: 'customTerm_' + index,
            class: 'guest-data__custom-term',
            isFormArray: false,
            validation: [Validators.requiredTrue],
            innerHTMLdata: true
          });
        });
      }
    }

    if (this.gs.restaurantWidgetSettings$.value.ConfirmationVia == ConfirmationVia.Both) {
      this.guestInfoConfig.push({
        type: 'checkbox',
        placeholder: this.ts.instant('smsConfirmationText'),
        value: false,
        name: 'reservationConfirmationBySMS',
        class: 'guest-data__confirmation-by-sms',
        isFormArray: false
      });
      this.guestInfoConfig.push({
        type: 'checkbox',
        placeholder: this.ts.instant('emailConfirmationText'),
        value: false,
        name: 'reservationConfirmationByEmail',
        class: 'guest-data__confirmation-by-email',
        isFormArray: false
      });
    }

    //Marketing
    if (this.gs.restaurantWidgetSettings$.value.MarketingFlagEnabled && this.gs.restaurantWidgetSettings$.value.MarketingFlagDescription) {
      this.guestInfoConfig.push({
        type: 'checkbox',
        placeholder: this.gs.restaurantWidgetSettings$.value.MarketingFlagDescription,
        value: this.gs.operation == operationType.edit && this.gs.editPartyData$.value.Contact.MarketingOptedIn ? this.gs.editPartyData$.value.Contact.MarketingOptedIn : false,
        name: 'marketingFlag',
        class: 'guest-data__marketing-flag',
        isFormArray: false,
        innerHTMLdata: true
      });
    }

    //Data Retention Policy
    this.dataRetentionPolicyExisting = false;
    if ((this.gs.operation != operationType.edit || this.gs.editFromCart) && this.gs.restaurantWidgetSettings$.value.IsGDPREnabled && this.gs.dataRetentionPolicy$.value && this.gs.dataRetentionPolicy$.value.PolicyDetails) {
      for (var i = 0; i < this.gs.dataRetentionPolicy$.value.PolicyDetails.length; i++) {
        var policyDetails = this.gs.dataRetentionPolicy$.value.PolicyDetails[i];
        switch (policyDetails.DataType) {
          case PolicyDataType.Name:
          case PolicyDataType.Address:
          case PolicyDataType.PhoneNumber:
          case PolicyDataType.EmailAddress:
          case PolicyDataType.GuestImage:
          case PolicyDataType.CustomGuestFields:
          case PolicyDataType.BirthdayAndAnniversary:
            if (policyDetails.RetentionInDays > 0) {
              this.dataRetentionPolicyExisting = true;
            }
            break;
          default:
            this.dataRetentionPolicyExisting = false;
            break;

        }
      }
    }
    if (this.dataRetentionPolicyExisting) {
      this.guestInfoConfig.push({
        type: 'checkbox',
        placeholder: this.ts.instant('dataRetentionCheckBoxText') + '<a href="/data_rentention_policy/restaurants/' + this.gs.restaurantWidgetName + '" target="_blank" >' + this.ts.instant('dataRetentionPolicy') + '</a>.',
        value: this.gs.editFromCart ? !!this.gs.editPartyData$.value.Contact.ConsentPolicyId : false ,
        name: 'dataRetention',
        class: 'guest-data__data-retention-policy',
        isFormArray: false,
        innerHTMLdata: true
      });
    }

  }

  showDataRententionPolicy() {
    let dataRetentionPolicyData = {
      customPolicyText: this.gs.restaurantWidgetSettings$.value.CustomPolicyText ? this.gs.restaurantWidgetSettings$.value.CustomPolicyText : this.ts.instant('serverBetter'),
      policyDetails: this.gs.dataRetentionPolicy$.value.PolicyDetails,
      fromClient: false // Need to bind based on Url launched
    }
    const componentDetails: ComponentDetails = Utilities.setComponentDetails(DataRetentionPolicyComponent, 'small', '', dataRetentionPolicyData,
      this.ts.instant('guestConsentPolicy'));
    this.dataRetentionPolicyDialogRef = this.openCustomPopup(componentDetails, ComponentTypes.dataRetentionPolicy, dataRetentionPolicyData.fromClient ? '50%' : '40%', dataRetentionPolicyData.fromClient ? '80%' : '60%', false, this.ts.instant('No'), this.ts.instant('Yes'),
      '', false)
  }
  getAgreeTermsAndConditionsText(): string {
    let text = "";
    text = this.ts.instant('agree') + '<a href="'+environment.app_base_href+'/Terms_Of_Use/restaurants/' + this.restaurantName + '" target="_blank" >' + this.ts.instant('termsOfUse') + '</a>' + this.ts.instant('and')
      + '<a href="'+environment.app_base_href+'/Privacy_Policy/restaurants/' + this.restaurantName + '" target="_blank" >' + this.ts.instant('privacyPolicy') + '</a>';
    return text;
  }
  ngAfterViewInit() {
    const allNotes = {};
    for (const addInfo of this.guestInfoConfig) {
      allNotes[addInfo.name] = '';
    }
    this.notesFormGroup = this.fb.group(allNotes);
    // if (!this.gs.additionalGuestPage && this.gs.operation != operationType.edit) {
    //   this.gs.primaryContact ? this.components.first.form.controls.phone.setValue(this.gs.primaryContact.PhoneNumber):this.components.first.form.controls.phone.setValue(''); //to remove the cuntryId binded as value in the input field
    //   this.guestDetailsForm = this.fb.group({
    //     primaryGuest: this.components.first.form
    //   })
    //   // this.guestDetailsForm.addControl('primaryGuest', this.notesFormGroup);
    // }
    if (this.gs.additionalGuestPage && this.gs.operation != operationType.edit) {
      this.guestDetailsForm = this.fb.group({
        secondaryGuest1: this.components.first.form
      })
      //   this.guestDetailsForm.addControl('secondaryGuest1', this.notesFormGroup);
    }
    else {
      this.gs.primaryContact ? this.components.first.form.controls.phone.setValue(this.gs.primaryContact.PhoneNumber) : this.components.first.form.controls.phone.setValue(''); //to remove the cuntryId binded as value in the input field
      this.guestDetailsForm = this.fb.group({
        primaryGuest: this.components.first.form,
        //   secondaryContactList: ''
      })
    }
    if (this.guestDetailsForm) {
      if (this.gs.additionalGuestPage && this.gs.operation != operationType.edit) {
        this.components.first.form.controls.firstName.patchValue('');
        this.components.first.form.controls.lastName.patchValue('')
        this.components.first.form.controls.phone.patchValue(this.gs.primaryContact.PhoneNumber);
        this.components.first.form.controls.email.patchValue(this.gs.primaryContact.EmailAddress);
        this.primaryGuestPhone = this.gs.primaryContact.PhoneNumber;
        this.primaryGuestEmail = this.gs.primaryContact.EmailAddress;
      }
      else if (!this.gs.additionalGuestPage && this.gs.operation == operationType.edit) {
        this.primaryGuestPhone = this.guestDetailsForm.get('primaryGuest').value.phone;
        this.primaryGuestEmail = this.guestDetailsForm.get('primaryGuest').value.email;
        this.components.first.form.patchValue(this.guestDetailsForm.get('primaryGuest').value);
        this.bindPreferencesCategoryToForm(this.components.first.form, this.gs.primaryContact);
        if (this.gs.secondaryContactList && this.gs.secondaryContactList.length > 0) {
          this.components.toArray().forEach((formData, index) => {
            if (index > 0) {
              this.bindContactsToForm(formData.form, this.gs.secondaryContactList[index - 1]);
              let fc = new FormControl(this.gs.secondaryContactList[index - 1].Id);
              formData.form.addControl("id", fc);
            }
          });
          let secondaryContactList = this.buildSecondaryContactList();
          (this.guestDetailsForm as FormGroup).addControl('secondaryContactList', this.fb.array(secondaryContactList.map(contact => this.fb.group(contact))));
        }
      }
      else if (!this.gs.additionalGuestPage && this.gs.operation != operationType.edit) {
        this.components.first.form.patchValue(this.guestDetailsForm.get('primaryGuest').value)
        this.components.first.form.controls["agreeTerms"].setValue(false, { emitEvent: false });
        if (this.components.first.form.controls["dataRetention"]) {
          this.components.first.form.controls["dataRetention"].setValue(false, { emitEvent: false });
        }
        if (this.gs.restaurantWidgetSettings$.value.WidgetCustomization.CustomTermsOfService && this.gs.restaurantWidgetSettings$.value.WidgetCustomization.CustomTermsOfService.length > 0) {
          this.gs.restaurantWidgetSettings$.value.WidgetCustomization.CustomTermsOfService.forEach((customTerm, index) => {
            this.components.first.form.controls['customTerm_' + index].setValue(false, { emitEvent: false });
          });
        }
      }
    }
    else {
      if (this.gs.operation == operationType.edit && !this.gs.additionalGuestPage) {
        this.components.toArray().forEach((formData, index) => {
          if (index == 0) {
            this.bindContactsToForm(formData.form, this.gs.primaryContact)
          }
          else {
            this.bindContactsToForm(formData.form, this.gs.secondaryContactList[index - 1]);
            let fc = new FormControl(this.gs.secondaryContactList[index - 1].Id);
            formData.form.addControl("id", fc);
          }
        });

        this.primaryGuestPhone = this.components.first.form.value.phone;
        this.primaryGuestEmail = this.components.first.form.value.email;
      }
      //this.bindSecondaryContactsToForm();
      //this.gs.reservationFormGroup.addControl('guestDetailsForm', this.guestDetailsForm);
      let secondaryContactList = this.buildSecondaryContactList();
      (this.guestDetailsForm as FormGroup).addControl('secondaryContactList', this.fb.array(secondaryContactList.map(contact => this.fb.group(contact))));
    }

    this.subscriptions.add(this.guestDetailsForm.valueChanges.subscribe(data => {
      this.confirmButton.disbaledproperity = this.guestDetailsForm.invalid || !this.isUserAllowedToclickConfirm || !this.checkCustomTermsAndMessageOptionValidation();
      this.addToButton.disbaledproperity = this.guestDetailsForm.invalid || !this.isUserAllowedToclickConfirm || !this.checkCustomTermsAndMessageOptionValidation() ;
      this.bookBtn.disbaledproperity = this.guestDetailsForm.invalid || !this.checkCustomTermsAndMessageOptionValidation();
    }));
    this.components.forEach(dynamicForm => {
      dynamicForm.form.valueChanges.subscribe(data => {
        dynamicForm.form.controls.firstName.setValue(dynamicForm.form.controls.firstName.value ? this.titleCasePipe.transform(dynamicForm.form.controls.firstName.value) : dynamicForm.form.controls.firstName.value, { emitEvent: false });
        dynamicForm.form.controls.lastName.setValue(dynamicForm.form.controls.lastName.value ? this.titleCasePipe.transform(dynamicForm.form.controls.lastName.value) : dynamicForm.form.controls.lastName.value, { emitEvent: false });
        this.confirmButton.disbaledproperity = dynamicForm.form.invalid || !this.isUserAllowedToclickConfirm || !this.checkCustomTermsAndMessageOptionValidation();
        this.addToButton.disbaledproperity = this.guestDetailsForm.invalid || !this.isUserAllowedToclickConfirm || !this.checkCustomTermsAndMessageOptionValidation();
        this.bookBtn.disbaledproperity = this.guestDetailsForm.invalid || !this.checkCustomTermsAndMessageOptionValidation();
      })
    });
    this.components.forEach(dynamicForm => {
      dynamicForm.form.valueChanges.subscribe(data => {
        dynamicForm.form.controls.firstName.setValue(dynamicForm.form.controls.firstName.value ? this.titleCasePipe.transform(dynamicForm.form.controls.firstName.value) : dynamicForm.form.controls.firstName.value, { emitEvent: false });
        dynamicForm.form.controls.lastName.setValue(dynamicForm.form.controls.lastName.value ? this.titleCasePipe.transform(dynamicForm.form.controls.lastName.value) : dynamicForm.form.controls.lastName.value, { emitEvent: false });
        this.confirmButton.disbaledproperity = dynamicForm.form.invalid || !this.isUserAllowedToclickConfirm || !this.checkCustomTermsAndMessageOptionValidation();
      })
    })

  }

  getCountryCode(code) {
    let country = this.countryCodes.find(country => country.CountryPhoneCode === code);
    country ? country.Id : code;
  }

  termsOfUse() {
    this.gs.nextButton.next(componentName.terms_of_use)
  }

  addToCartData() {
    const cartObj = this.buildReservationRequest(true, true);
    this.cartEvents = { isAdd: true };
    this.gs.validateCart(cartObj).subscribe(data => {
      if (data.ValidationMessages.length) {
        //this.openConfirmationDialog(data, data.ValidationMessages[0].Message,);
      }
      else {
        this.addtoCartDataSuccessHandler(cartObj);
      }
    })
   
  }

  addtoCartDataSuccessHandler(cartObj?: any) {
    this.cartEvents = null;
    if(!cartObj) cartObj = this.buildReservationRequest(true, true);
    this.addToCart(cartObj);
        this.unlockSessions();
        this.gs.bookingSection$.next(BookingActivity.ClassBooking);
        this.gs.TabChange$.next(ActivityTabs.BookingSelection);
        this.gs.setMessageState(this.ts.instant('addedToCartSuccessfully'), 1);
        const crypto = window.crypto;
        var array = new Uint32Array(1);
        this.gs.CartBookingList$.next(crypto.getRandomValues(array));
  }

  addToCart(request) {
    request = Object.assign(request, this.gs.SaveBookingObj);
    let cartObj = JSON.parse(sessionStorage.getItem('CartList'));
    if (cartObj && cartObj.length) {
      cartObj.push(request);
    } else {
      cartObj = [];
      cartObj.push(request);
    }
    sessionStorage.setItem('CartList', JSON.stringify(cartObj));
  }


  goBackToReservation() {
    this.resetPaymentInfo();
    this.gs.setMessageState('', 0);
    this.unlockSessions();
    if (this.gs.bookingSection$.value === BookingActivity.OpenBooking) {
      this.gs.TabChange$.next(ActivityTabs.BookingSelection);
    } else if (this.gs.bookingSection$.value === BookingActivity.ClassBooking) {
      this.gs.TabChange$.next(ActivityTabs.ActivitySelection);
    } else {
      this.gs.TabChange$.next(ActivityTabs.PrivateLesson);
    }
  }

  unlockSessions() {
    if (this.gs.bookingSection$.value === BookingActivity.ClassBooking && this.gs.lockResult && this.gs.lockResult.SlotLockIdDTO) {
      this.gs.unlockSessionsUrl(this.gs.lockResult.SlotLockIdDTO.Id).subscribe(data => {
        this.gs.lockResult = null;
        this.gs.offTimer();
      });
    } else if (this.gs.lockMultipleResult) {
      const lockData = Object.values(this.gs.lockMultipleResult) as SlotLockResultDTO[];
      const LockIds = lockData.map(x => x?.SlotLockIdDTO?.Id);
      this.gs.releaseMultiple(LockIds).subscribe(data => {
        this.gs.lockMultipleResult = null;
        this.gs.offTimer();
      });
    }
  }

  reservationConfirm(isOverlapBooking: boolean = false) {
    this.gs.setMessageState('', 0);
    /*     if (this.gs.additionalGuestPage) {
          this.createSecondaryContacts();
        }
        else */
    this.gs.isOverlapErrorFromValidateCartApi = false;
    let partyDtoRequired = this.buildReservationRequest(true);
    if (this.gs.operation == operationType.edit && this.gs.editPartyData$.value) {
      if (!this.isPartySizeMatchSecondaryContactList()) {
        this.gs.setMessageState(this.ts.instant('partySizeMisMatchError'), 0);
        return;
      }
      let secondaryContactList = this.buildSecondaryContactList();
      (this.guestDetailsForm as FormGroup).addControl('secondaryContactList', this.fb.array(secondaryContactList.map(contact => this.fb.group(contact))));
      if (this.isAuthRefund) {
        partyDtoRequired.refundData = this.gs.refundData;
      }
      this.updateReservation(partyDtoRequired, isOverlapBooking);
    } else {
      this.CreateReservation(partyDtoRequired, isOverlapBooking);
    }
  }
  getSeatSelection() {
    this.guestDetailsForm.reset();
  }
  trackByGuest(guest: any): number {
    return guest;
  }

  UpdateCart() {
    let cartObj = this.buildReservationRequest(true, true);
    this.cartEvents = { isUpdate: true };
    this.gs.validateCart(cartObj).subscribe(data => {
      if (data.ValidationMessages.length) {
        //this.openConfirmationDialog(data, data.ValidationMessages[0].Message,);
      }
      else {
        this.updateCartSuccessHandler(cartObj);
      }
    })
  }

  updateCartSuccessHandler(cartObj?: any) {
    this.cartEvents = null;
    if(!cartObj) cartObj = this.buildReservationRequest(true, true);
    
    cartObj = Object.assign(cartObj, this.gs.SaveBookingObj)
    this.gs.CartBookingList$.next(cartObj);
    let CartList = JSON.parse(sessionStorage.getItem('CartList'));
    CartList[this.gs.selectedCartIndex] = cartObj;
    sessionStorage.setItem('CartList', JSON.stringify(CartList));
    this.gs.TabChange$.next(ActivityTabs.CartDetails);
    this.gs.editFromCart = false;
    this.unlockSessions();
  }


  additionalGuest() {
    this.guestData.push({ name: this.ts.instant('secondaryGuest') + (this.guestData.length + 1), isNew: true });
    this.SaveGuestbtn.disbaledproperity = true;
    setTimeout(() => {
      this.components.last.form.controls.firstName.setValue('');
      this.components.last.form.controls.lastName.setValue('');
      this.components.forEach(queryForm => {
        queryForm.form.valueChanges.subscribe(data => {
          queryForm.form.controls.firstName.setValue(queryForm.form.controls.firstName.value ? this.titleCasePipe.transform(queryForm.form.controls.firstName.value) : queryForm.form.controls.firstName.value, { emitEvent: false });
          queryForm.form.controls.lastName.setValue(queryForm.form.controls.lastName.value ? this.titleCasePipe.transform(queryForm.form.controls.lastName.value) : queryForm.form.controls.lastName.value, { emitEvent: false });
          this.SaveGuestbtn.disbaledproperity = queryForm.form.invalid || !this.isUserAllowedToclickConfirm || !this.checkCustomTermsAndMessageOptionValidation();
        });
        if (!queryForm.form.controls.phone.touched && !queryForm.form.controls.phone.touched) {
          queryForm.form.controls.phone.patchValue(this.primaryGuestPhone, { emitEvent: false });
        }
        if (!queryForm.form.controls.email.touched && !queryForm.form.controls.email.value) {
          queryForm.form.controls.email.patchValue(this.primaryGuestEmail, { emitEvent: false });
        }
      })
      this.subscribeMemberConfig();
    }, 250);

  }

  subscribeMemberConfig() {
    this.memberForm.forEach((formObj, index) => {
      formObj.form.valueChanges.subscribe(value => {
        if (value.MembershipId && value.MembershipId.length === 16) {
          this.gs.getContactFromEngagebyCardno(value.MembershipId).subscribe(({ Payload: response }) => {
            var srcForm = this.components["_results"][index + (this.gs.additionalGuestPage ? 0 : 1)];
            let country = this.countryCodes.find(country => country.CountryPhoneCode === response.PhoneCode);
            srcForm.form.controls.firstName.setValue(response.FName, { emitEvent: false });
            srcForm.form.controls.lastName.setValue(response.LName, { emitEvent: false });
            srcForm.form.controls.phone.setValue(response.PhoneNumber, { emitEvent: false });
            srcForm.form.controls.email.setValue(response.Email, { emitEvent: false });
            if(this.guestInfoConfigSecondary){
              this.guestInfoConfigSecondary[2].value = country.Id;
            }else if(this.guestInfoConfig){
              this.guestInfoConfig[2].value = country.Id;
            }
          })
        }
      })
    });
  }


  bindContactsToForm(form, contact) {
    form.controls.firstName.setValue(contact.FirstName);
    form.controls.lastName.setValue(contact.LastName);
    form.controls.phone.setValue(contact.PhoneNumber);
    form.controls.email.setValue(contact.EmailAddress);
    this.bindPreferencesCategoryToForm(form, contact);
  }

  bindPreferencesCategoryToForm(form, contact) {
    let contactNotes = {};
    if (contact.Notes && contact.Notes.length > 0) {
      contact.Notes.forEach(note => {
        contactNotes[note.RelatedId] = true;
        if (this.freeTextIdList && this.freeTextIdList.length > 0 && this.freeTextIdList.findIndex(Id => Id == note.RelatedId) > -1 && note.Text) {
          form.controls[note.RelatedId.toString()].setValue(note.Text);
        }
      })
    }
    if (this.gs.restaurantWidgetSettings$.value.PreferencesCategories && this.gs.restaurantWidgetSettings$.value.PreferencesCategories.length > 0) {
      this.gs.restaurantWidgetSettings$.value.PreferencesCategories.filter(x => x.Text !== 'Reasons').forEach(category => {
        if (form.controls['preferences_' + category.Id.toString()]) {
          form.controls['preferences_' + category.Id.toString()].patchValue([contactNotes]);
        }
      });
    }
  }

  resetPaymentInfo() {
    this.gs.ispaymentInvolvedInfo = null;
    this.gs.reservationAttemptInfo = null;
  }

  GetPreliminaryReservationInformation() {
    //this.gs.GetPreliminaryReservationInformation(this.gs.SessionBookingObj.ActivityId).subscribe(data => {
      //if (data) {
        //this.RegisterReservationAttempt();
        //this.gs.ispaymentInvolvedInfo = data;
        if (this.partyDetails?.specialMeal?.WaiverFormCode || this.gs.SelectedActivity$.value?.WaiverFormCode || (this.gs.restaurantWidgetSettings$.value.DefaultWaiverForm && this.gs.restaurantWidgetSettings$.value.DefaultWaiverForm.Applied)) {
          this.isUserAllowedToclickConfirm = false;
          this.LoadGuestWaiverForm(this.partyDetails?.specialMeal?.WaiverFormCode ? this.partyDetails?.specialMeal?.WaiverFormCode : this.gs.SelectedActivity$.value?.WaiverFormCode ? this.gs.SelectedActivity$.value?.WaiverFormCode : this.gs.restaurantWidgetSettings$.value.DefaultWaiverForm.FormCode) // disable confirm button
          this.addToButton.disbaledproperity = true;
        }
        else {
          //this.addToButton.disbaledproperity = false;
          //if (this.gs.ispaymentInvolvedInfo.CreditCardRequired) {
            this.isUserAllowedToclickConfirm = false;
            this.RegisterReservationAttempt(true) // diable confirm button
          //}
          //else {
            //this.isUserAllowedToclickConfirm = true; //No payement no waiver form ,guest can create Reservation
          //}
        }

      //}

      // else {
      //   this.isUserAllowedToclickConfirm = false;//Some Error While Processing
      // }

    //});
  }

  getOpenbookingSlotwithIds() {
    return this.paymentData?.Slots?.map(data => {
      return {
        ReservationAttemptId: data.ReservationAttemptId,
        SlotTime: data.LocalTime
      }
    })
  }

  buildReservationRequest(isBookingApiRequest: boolean = false, isValidateCartApi: boolean = false) {
    this.gs.SaveBookingObj.Contact = {
      FirstName: this.guestDetailsForm.value.primaryGuest.firstName,
      LastName: this.guestDetailsForm.value.primaryGuest.lastName,
      EmailAddress: this.guestDetailsForm.value.primaryGuest.email,
      PhoneNumber: this.guestDetailsForm.value.primaryGuest.phone,
      PIILastUsedDate: moment(new Date()).format('YYYY-MM-DDTHH:mm:ss'),
      ContactCustomFields: this.getCustomGuestFieldsValue(),
      CountryId: this.gs.selectedCountryId, // map country code
      Notes: this.getCategoryPreferencesNotes(this.guestDetailsForm.value.primaryGuest),
      MarketingOptedIn: this.guestDetailsForm.value.primaryGuest.marketingFlag ? this.guestDetailsForm.value.primaryGuest.marketingFlag : (this.gs.operation == operationType.edit && (!this.gs.restaurantWidgetSettings$.value.MarketingFlagEnabled || !this.gs.restaurantWidgetSettings$.value.MarketingFlagDescription) && this.gs.editPartyData$.value.Contact.MarketingOptedIn) ? this.gs.editPartyData$.value.Contact.MarketingOptedIn : null,
      TrackMembershipNumber: this.gs.selectedGuest?.TrackMembershipNumber,
      memberShipId: this.gs.selectedGuest?.memberShipId,
      MemberType: this.gs.selectedGuest?.MembershipType,
      IsMemberActive: this.gs.selectedGuest?.MemberActive
    };
    const bookingData = this.gs.SaveBookingObj;

    let partyDTO: any = {
      Id: this.gs.operation == operationType.edit ? this.gs.editPartyData$.value.Id : null,
      Size: bookingData.Size,
      RemindAboutVisit: this.gs.restaurantWidgetSettings$.value.IsSmsReminderSupported ? this.gs.restaurantWidgetSettings$.value.WidgetCustomization.IsReservationReminderMandatory ? true : this.guestDetailsForm.value.primaryGuest['RemindBySMS'] : false,// get Value froom form
      RemindAboutVisitEmail: this.guestDetailsForm.value.primaryGuest['RemindByEmail'],//
      AgreedWithTermsOfUse: true,
      Contact: bookingData.Contact,
      BookingTypes: this.getBookingTypes(),
      CoverTypes: this.getCoverTypes(),
      Slot: bookingData.Slot,
      Slots: bookingData.Slots,
      Sessions: bookingData.Sessions,
      PartyId: this.gs.operation == operationType.edit ? this.gs.editPartyData$.value.Id : null,
      BookingId: this.gs.operation == operationType.edit ? this.gs.editPartyData$.value.BookingId : null,
      SpecialMealId: this.gs.operation == operationType.create ? bookingData.SpecialMealId : bookingData.SpecialMealId,
      ConfirmationMessageOption: this.getConfirmationMessageOption(),
      TableIds: bookingData.TableIds,
      InstructorIds: bookingData.StaffId,
      Notes: this.getNotes(),
      IsCommunalTable: false,
      FromWebsite: true,
      Language: this.gs.language, // get language id
      ReservationAttemptId: this.gs.reservationAttemptInfo && this.gs.reservationAttemptInfo.ReservationAttemptId ? this.gs.reservationAttemptInfo.ReservationAttemptId : null,
      WaiverFormTransactionId: this.waiverFormTrancationId ? this.waiverFormTrancationId : (this.gs.operation == operationType.edit && this.gs.editPartyData$.value.WaiverFormTransactionId) ? this.gs.editPartyData$.value.WaiverFormTransactionId : null,
      BookingBehavior: this.gs.bookingSection$.value,
      StartDate: bookingData.StartDate,
      EndDate: bookingData.EndDate,
      ReservationAttemptIdWithSlotDTOList: this.gs.bookingSection$.value !== BookingActivity.ClassBooking ? this.getOpenbookingSlotwithIds() : [],
      BookingContacts: this.gs.operation == operationType.edit ? this.buildSecondaryContactList() : null,
      IsForStandbyReservations: this.gs.selectedSpecialMeal?.IsForStandbyReservations || null,
      isBookingApiRequest: (isBookingApiRequest || this.gs.bShowOverbookingErrorDialog),
      isValidateCartApi
    };
    if (!this.gs.bookingSection$.value && this.gs.operation === operationType.edit) {
      partyDTO.Slot = bookingData.Slots[0];
      partyDTO.Slots = null;
    }
    if(this.gs.SelectedActivity$ && this.gs.SelectedActivity$.value && this.gs.SelectedActivity$.value.ImageData){
      partyDTO.bannerImage = this.gs.SelectedActivity$.value.ImageData
    }
    //   !this.gs.bookingSection$.value && this.gs.operation === operationType.edit ? bookingData.Slots : bookingData.Slot,
    // let partyDTO: any = {
    //   Id: this.gs.operation == operationType.edit ? this.gs.editPartyData$.value.Id : null,
    //   Size: this.partyDetails.partySize,
    //   RemindAboutVisit: this.gs.restaurantWidgetSettings$.value.IsSmsReminderSupported ? this.gs.restaurantWidgetSettings$.value.WidgetCustomization.IsReservationReminderMandatory ? true : this.guestDetailsForm.value.primaryGuest['reservationBySMS'] : false,// get Value froom form
    //   RemindAboutVisitEmail: this.guestDetailsForm.value.primaryGuest['reservationByEmail'],//
    //   AgreedWithTermsOfUse: true,
    //   Contact: {
    //     FirstName: this.guestDetailsForm.value.primaryGuest.firstName,
    //     LastName: this.guestDetailsForm.value.primaryGuest.lastName,
    //     EmailAddress: this.guestDetailsForm.value.primaryGuest.email,
    //     PhoneNumber: this.guestDetailsForm.value.primaryGuest.phone,
    //     PIILastUsedDate: moment(new Date()).format('YYYY-MM-DDTHH:mm:ss'),
    //     ContactCustomFields: this.getCustomGuestFieldsValue(),
    //     CountryId: this.gs.selectedCountryId, // map country code
    //     Notes: this.getCategoryPreferencesNotes(this.guestDetailsForm.value.primaryGuest),
    //     MarketingOptedIn: this.guestDetailsForm.value.primaryGuest.marketingFlag ? this.guestDetailsForm.value.primaryGuest.marketingFlag : (this.gs.operation == operationType.edit && (!this.gs.restaurantWidgetSettings$.value.MarketingFlagEnabled || !this.gs.restaurantWidgetSettings$.value.WidgetCustomization.MarketingFlagDescription) && this.gs.editPartyData$.value.Contact.MarketingOptedIn) ? this.gs.editPartyData$.value.Contact.MarketingOptedIn : null
    //   },
    //   Slot: {
    //     Time: moment(this.partyDetails.reservationTime).format('YYYY-MM-DDTHH:mm:ss'),
    //     LockId: this.gs.lockResult.SlotLockIdDTO.Id,
    //     Type: 4 //"AutodetectSlot"
    //   },
    //   PartyId: this.gs.operation == operationType.edit ? this.gs.editPartyData$.value.Id : null,
    //   SeatingAreaId: this.partyDetails.seatingArea.id > 0 ? this.partyDetails.seatingArea.id : null,
    //   SpecialMealId: this.partyDetails.specialMeal.Id,
    //   SeatingTypeId: this.partyDetails.seatingType.id > 0 ? this.partyDetails.seatingType.id : null,
    //   ConfirmationMessageOption: this.getConfirmationMessageOption(),
    //   Notes: this.getNotes(),
    //   TableIds: this.partyDetails.tableId && this.partyDetails.tableId.length > 0 ? this.partyDetails.tableId : [],
    //   CoverTypes: this.getCoverTypes(),//Bind Cover types
    //   IsCommunalTable: this.partyDetails.communalAvailability,
    //   FromWebsite: true,
    //   Language: this.gs.language, // get language id
    //   ReservationAttemptId: this.gs.reservationAttemptInfo && this.gs.reservationAttemptInfo.ReservationAttemptId ? this.gs.reservationAttemptInfo.ReservationAttemptId : null,
    //   waiverFormTransactionId: this.waiverFormTrancationId ? this.waiverFormTrancationId : (this.gs.operation == operationType.edit && this.gs.editPartyData$.value.WaiverFormTransactionId) ? this.gs.editPartyData$.value.WaiverFormTransactionId : null,
    //   BookingContacts: this.gs.operation ==operationType.edit ? this.buildSecondaryContactList() : null
    // };

    if ((this.gs.operation != operationType.edit || this.gs.editFromCart) && this.guestDetailsForm.value.primaryGuest.dataRetention) {
      partyDTO.Contact.ConsentDate = moment(new Date()).format('YYYY-MM-DDTHH:mm:ss');
      partyDTO.Contact.ConsentPolicyId = this.gs.dataRetentionPolicy$.value.Id;
    }

    if(this.gs.SaveBookingObj && this.waiverFormTrancationId){
      this.gs.SaveBookingObj.WaiverFormTransactionId = this.waiverFormTrancationId ? this.waiverFormTrancationId : (this.gs.operation == operationType.edit && this.gs.editPartyData$.value.WaiverFormTransactionId) ? this.gs.editPartyData$.value.WaiverFormTransactionId : null;
    }

    return partyDTO;
  }

  getCategoryPreferencesNotes(formValue) {
    let contactNotes = [];
    if (this.gs.restaurantWidgetSettings$.value.PreferencesCategories && this.gs.restaurantWidgetSettings$.value.PreferencesCategories.length > 0) {
      this.gs.restaurantWidgetSettings$.value.PreferencesCategories.filter(x => x.Text !== 'Reasons').forEach(category => {
        let predefinedNotes = []
        if (formValue['preferences_' + category.Id.toString()]) {
          let userSelectedPredefinedNotesList = formValue['preferences_' + category.Id.toString()][0];
          category.SubCategories && category.SubCategories.length > 0 ? category.SubCategories.map(x => {
            if (x.PredefinedContactNote && x.PredefinedContactNote.length > 0) {
              x.PredefinedContactNote.forEach(note => {
                predefinedNotes.push(note)
              });
            }
          }) : [];
          if (predefinedNotes && predefinedNotes.length > 0) {
            let existingContactNoteId;
            predefinedNotes.forEach(note => {
              if (this.gs.operation == operationType.edit && this.gs.editPartyData$.value.Contact.Notes && this.gs.editPartyData$.value.Contact.Notes.length > 0) {
                existingContactNoteId = this.gs.editPartyData$.value.Contact.Notes.filter(x => x.RelatedId == note.Id)[0];
              }
              if (userSelectedPredefinedNotesList[note.Id.toString()]) {
                contactNotes.push({
                  RelatedId: note.Id,
                  Text: note.Text,
                  Id: existingContactNoteId && existingContactNoteId.Id ? existingContactNoteId.Id : null
                });
              }
            })
          }
        }
      })

      if (this.freeTextIdList && this.freeTextIdList.length > 0) {
        this.freeTextIdList.forEach(freeTextId => {
          let existingContactNoteId: any = this.gs.operation == operationType.edit && this.gs.editPartyData$.value.Contact.Notes && this.gs.editPartyData$.value.Contact.Notes.length > 0 ? this.gs.editPartyData$.value.Contact.Notes.filter(x => x.RelatedId == freeTextId)[0] : '';
          if (formValue[freeTextId.toString()]) {
            contactNotes.push({
              RelatedId: freeTextId,
              Text: formValue[freeTextId.toString()],
              Id: existingContactNoteId && existingContactNoteId.Id ? existingContactNoteId.Id : null
            });
          }
        });
      }

    }
    return contactNotes;
  }

  getNotes() {
    let notes = [];
    //Map Promocode Value
    let promoCodeValue = '';
    promoCodeValue = this.guestDetailsForm.value.primaryGuest.promocode;
    if (promoCodeValue) {
      let promoCode = { Type: 3, Text: promoCodeValue };
      notes.push(promoCode);
    }

    return notes;
  }

  getConfirmationMessageOption() {
    if (this.gs.restaurantWidgetSettings$.value.ConfirmationVia == ConfirmationVia.Both) {
      if (this.guestDetailsForm.value.primaryGuest['reservationConfirmationByEmail']
        && this.guestDetailsForm.value.primaryGuest['reservationConfirmationBySMS']) {
        return ConfirmationVia.Both;
      }
      else if (this.guestDetailsForm.value.primaryGuest['reservationConfirmationByEmail']) {
        return ConfirmationVia.Email;
      }
      else if (this.guestDetailsForm.value.primaryGuest['reservationConfirmationBySMS']) {
        return ConfirmationVia.Sms;
      }
      else {
        return this.gs.restaurantWidgetSettings$.value.ConfirmationVia;
      }
    }
    else {
      return this.gs.restaurantWidgetSettings$.value.ConfirmationVia;
    }
  }

  getContactNotes() {
    return [];
  }
  getCustomGuestFieldsValue() {
    let CustomFieldsList: CustomFieldsDTO[] = [];
    if (this.gs.customGuestFields && this.gs.customGuestFields.CustomGuestField.length > 0) {
      this.gs.customGuestFields.CustomGuestField.forEach(field => {
        if (this.guestDetailsForm.value.primaryGuest['customGuestField_' + field.Id.toString()] != null) {
          let customField = new CustomFieldsDTO();
          customField.CustomFieldId = Number(field.Id);
          customField.CustomFieldValue = this.guestDetailsForm.value.primaryGuest['customGuestField_' + field.Id.toString()];
          customField.CustomFieldName = field.FieldName;
          CustomFieldsList.push(customField);
        }
      })
    }
    return CustomFieldsList;
  }

  getCoverTypes(): any {
    // let coverTypesList: CoverTypeQuantityDTO[] = [];
    // if (this.gs.reservationFormGroup.controls.reservationDetailsForm.value.specialMeal &&
    //   this.gs.reservationFormGroup.controls.reservationDetailsForm.value.coverTypes &&
    //   this.gs.reservationFormGroup.controls.reservationDetailsForm.value.specialMeal.CoverTypePrices) {
    //   this.gs.reservationFormGroup.controls.reservationDetailsForm.value.specialMeal.CoverTypePrices.forEach(coverType => {
    //     let coverTypeDto = new CoverTypeQuantityDTO();
    //     coverTypeDto.CoverTypeId = coverType.Id;
    //     coverTypeDto.CoverTypeName = coverType.CoverTypeName;
    //     coverTypeDto.Covers = this.gs.reservationFormGroup.controls.reservationDetailsForm.value.coverTypes[coverType.Id.toString()]
    //     coverTypesList.push(coverTypeDto);
    //   });
    // }
    // return coverTypesList;
    return this.gs.SaveBookingObj?.CoverTypes;
  }

  getBookingTypes(): any {

    return this.gs.SaveBookingObj?.BookingTypes;
  }

  updateReservation(partyDto, isOverlapBooking: boolean = false) {
    this.gs.updateSessionBooking(partyDto, isOverlapBooking).subscribe(data => {
      if (data) {
        this.completeReservation(false);
        if (this.gs.bookingSection$.value) {
          let partyType = this.gs.selectedSpecialMeal ? this.gs.selectedSpecialMeal.IsForStandbyReservations ? PartyType[2] : PartyType[0] : '';

          this.gs.getByToken(data.Token, '', partyType).subscribe(data => {
            this.gs.editPartyData$.next(data);
          });
        } else {
          let PartiesData: any;
          if (data.BookingId) {
            this.gs.getByToken('', data.BookingId).subscribe(party => {
              if (Array.isArray(party)) {
                PartiesData = party;
              }
              else {
                PartiesData = [];
                PartiesData.push(party)
              }
              this.gs.bookingPartiesData$.next(PartiesData);
            });
          } else {
            let partyType = this.gs.selectedSpecialMeal ? this.gs.selectedSpecialMeal.IsForStandbyReservations ? PartyType[2] : PartyType[0] : '';
            this.gs.getByToken(data.Token, '', partyType).subscribe(data => {
              PartiesData = [];
              PartiesData.push(data)
              this.gs.bookingPartiesData$.next(PartiesData);
            });
          }
        }

      }
    });
  }

  CreateReservation(partyDto, isOverlapBooking: boolean = false) {
    //have to check
    // this.gs.SaveBookingObj.Contact = {
    //       FirstName: this.guestDetailsForm.value.primaryGuest.firstName,
    //       LastName: this.guestDetailsForm.value.primaryGuest.lastName,
    //       EmailAddress: this.guestDetailsForm.value.primaryGuest.email,
    //       PhoneNumber: this.guestDetailsForm.value.primaryGuest.phone,
    //       PIILastUsedDate: moment(new Date()).format('YYYY-MM-DDTHH:mm:ss'),
    //       ContactCustomFields: this.getCustomGuestFieldsValue(),
    //       CountryId: this.gs.selectedCountryId, // map country code
    //       Notes: this.getCategoryPreferencesNotes(this.guestDetailsForm.value.primaryGuest),
    //       MarketingOptedIn: this.guestDetailsForm.value.primaryGuest.marketingFlag ? this.guestDetailsForm.value.primaryGuest.marketingFlag : (this.gs.operation == operationType.edit && (!this.gs.restaurantWidgetSettings$.value.MarketingFlagEnabled || !this.gs.restaurantWidgetSettings$.value.WidgetCustomization.MarketingFlagDescription) && this.gs.editPartyData$.value.Contact.MarketingOptedIn) ? this.gs.editPartyData$.value.Contact.MarketingOptedIn : null
    //     }
    //this.gs.TabChange$.next(4);

    this.gs.createSessionBooking(partyDto, isOverlapBooking).subscribe(data => {
      if (data) {
        this.gs.createActivityResponse$.next(data);
        this.gs.primaryContact = partyDto.Contact;
        this.completeReservation(true);
        let partyType = this.gs.selectedSpecialMeal ? this.gs.selectedSpecialMeal.IsForStandbyReservations ? PartyType[2] : PartyType[0] : '';
        if (this.gs.bookingSection$.value === BookingActivity.ClassBooking) {
          this.gs.getByToken(data.Token, '', partyType).subscribe(data => {
            this.gs.editPartyData$.next(data);
          });
        } else {
          let PartiesData: any;
          const responseTimeSlots: any = Object.values(data.NewParties);
          if (responseTimeSlots.length > 1) {
            this.gs.getByToken('', responseTimeSlots[0].BookingId, partyType).subscribe(party => {
              if (Array.isArray(party)) {
                PartiesData = party;
              }
              else {
                PartiesData = [];
                PartiesData.push(party)
              }
              this.gs.editPartyData$.next(PartiesData[0]);
              this.gs.bookingPartiesData$.next(PartiesData);
            });
          } else {
            this.gs.getByToken(responseTimeSlots[0].Token, '', partyType).subscribe(data => {
              PartiesData = [];
              PartiesData.push(data)
              this.gs.editPartyData$.next(data);
              this.gs.bookingPartiesData$.next(PartiesData);
            });
          }
        }
      }
    });
  }

  completeReservation(data) {
    this.gs.offTimer();
    this.gs.TabChange$.next(ActivityTabs.ConfirmationSummary);
    if (data) {
      this.gs.additionalGuestRequired = this.gs.SaveBookingObj.Size;
      this.gs.setAdditionalGuest(this.gs.additionalGuestRequired);
    }
  }

  RegisterReservationAttempt(isIframeToBeDisplayed: boolean) {
    let registerReservationAttemptRequestDTO = {
      PartySize: +this.gs.SaveBookingObj?.Size,
      Sessions: this.gs.SaveBookingObj?.Sessions,
      ActivityId: this.gs.SaveBookingObj?.Id,
      CoverTypes: this.gs.SaveBookingObj?.CoverTypes,
      TableIds: this.gs.SaveBookingObj?.TableIds,
      InstructorIds: this.gs.SaveBookingObj?.InstructorIds,
      BookingTypes: this.gs.SaveBookingObj?.BookingTypes,
      FromWebsite: true,
      Slots: this.gs.SaveBookingObj?.RatePlanTimeSlots,
      BookingBehavior: this.gs.SaveBookingObj?.BookingBehavior,
      PartyId: this.gs.operation == operationType.edit && this.gs.editPartyData$.value ? this.gs.editPartyData$.value.Id : null,
      MemberType: this.gs.selectedGuest?.MembershipType,
      MemberActive: this.gs.selectedGuest?.MemberActive
    }

    if(registerReservationAttemptRequestDTO.BookingBehavior == BookingBehavior.ClassOrSession){
      registerReservationAttemptRequestDTO.Slots = []
    }
    else{
      registerReservationAttemptRequestDTO.Sessions = null;
    }

    // let registerReservationAttemptRequestDTO = {
    //   LocalTime: moment(this.partyDetails.reservationTime).format('YYYY-MM-DDTHH:mm:ss'),  //selected date and time
    //   PartySize: this.gs.reservationFormGroup.controls.reservationDetailsForm.value.partySize,
    //   SeatingAreaId: this.partyDetails.seatingArea.id > 0 ? this.partyDetails.seatingArea.id : null,
    //   SeatingTypeId: this.partyDetails.seatingType.id > 0 ? this.partyDetails.seatingType.id : null,
    //   TableId: this.partyDetails.tableId && this.partyDetails.tableId.length > 0 ? this.partyDetails.tableId : [],
    //   SpecialMealId: this.partyDetails.specialMeal.Id,
    //   CoverTypes: this.getCoverTypes(),
    //   IsCommunalTable: this.partyDetails.communalAvailability,
    //   FromWebsite: true,
    //   PartyId: this.gs.operation == operationType.edit && this.gs.editPartyData$.value ? this.gs.editPartyData$.value.Id : null
    // }
    this.gs.RegisterReservationAttempt(registerReservationAttemptRequestDTO).subscribe(data => {
      if (data) {
        this.paymentData = this.gs.reservationAttemptInfo = data;
        this.PaymentGateway = data.PaymentGateway;
        this.TotalAmount = data.PaymentAmount;
        if (data.RatePlanTotal) {
          this.setRatePlanData(data.RatePlanTotal);
          this.gs.PaymentData$.next(data);
          this.bindPaymentAmountAndMessage(this.paymentData.RateplanAmountinfo, this.paymentData.SpecialMealAmountinfo, this.paymentData.PaymentAmount)
        }
        if (!this.gs.restaurantWidgetSettings$.value.IsCartEnabled) {
          if (data.ShouldCreditCardBeEntered && isIframeToBeDisplayed) {
            if (this.gs.reservationAttemptInfo.CreditCardIFrameURL) {
              this.LoadIframe(this.gs.reservationAttemptInfo.CreditCardIFrameURL);
            }
            else {
              this.gs.setMessageState(this.ts.instant('SorryForPaymentOffline'), 0);
            }
          } else {
            if (!this.waiverForm) {
              this.isUserAllowedToclickConfirm = true;
            }
          }
        }
        else{
          if (!this.waiverForm) {
            this.isUserAllowedToclickConfirm = true;
          }
        }
        if (this.gs.operation == operationType.edit && this.gs.editPartyData$.value && this.gs.editPartyData$.value.Id) {
          this.getFinancialEffectCalculation();
        }
      }
    })

  }

  setRatePlanData(data) {
    this.ratePlan = data;
    if (this.ratePlan && this.ratePlan.RatePlanCalculations) {
      this.ratePlan.RatePlanCalculations = this.ratePlan.SlotList = this.ratePlan.RatePlanCalculations.map(slot => {
        slot.coverTypeVariants = slot.RatePlanVariants && slot.RatePlanVariants.GuestTypeVariant ? slot.RatePlanVariants.GuestTypeVariant.map(coverVariant => {
          coverVariant.CoverTypeName = this.gs.SaveBookingObj.CoverTypes.find(coverType => coverType.CoverTypeId == coverVariant.CoverTypeId).Name;
          return coverVariant;
        }).filter(coverVariant => coverVariant.Variant) : [];
        slot.bookingTypeVariants = slot.RatePlanVariants && slot.RatePlanVariants.BookingTypeVariant ? slot.RatePlanVariants.BookingTypeVariant.map(bookingTypeVariant => {
          bookingTypeVariant.BookingTypeName = this.gs.SaveBookingObj.BookingTypes.find(bookingType => bookingType.BookingTypeId == bookingTypeVariant.BookingTypeId).Name;
          return bookingTypeVariant;
        }).filter(bookingTypeVariant => bookingTypeVariant.Variant) : [];
        return slot;
      });
    } else {
      this.ratePlan.SlotList = this.gs.SessionBookingObj.Slots;
    }
    if (this.ratePlan.TotalRatePlan || this.ratePlan.RatePlanCalculations) {
      this.gs.RatePlanList$.next(this.ratePlan);
    }
  }

  bindPaymentAmountAndMessage(ratePlanAmount, specialMealAmount, paymentAmount) {
    this.ratePlanAmountInfo = ratePlanAmount;
    this.specialMealAmountInfo = specialMealAmount;
    this.paymentAmountInfo = paymentAmount;
    if (ratePlanAmount > 0 || specialMealAmount > 0) { //Activity Payment Involved
      this.activityPayment = ratePlanAmount > 0 ? ratePlanAmount : 0;
      this.activityPayment = specialMealAmount > 0 ? this.activityPayment + specialMealAmount : this.activityPayment;

      if (this.isSelectedMealDefferedPayment()) {
        this.paymentMessage = this.ts.instant('PrePaidMealReservationAuthorize');
      }
      else {
        this.paymentMessage = this.ts.instant('CardWillBeChargedTotalPrePaidReservation');
      }
      this.gs.showPaymentSummary = true;
    }
    else if (paymentAmount > 0) {//noShow
      this.noShowfee = paymentAmount > 0 ? paymentAmount : 0;
      if (this.gs.restaurantWidgetSettings$.value.WidgetCustomization.CustomNoShowFeeTerms) {
        this.noShowfeeMessage = this.gs.restaurantWidgetSettings$.value.WidgetCustomization.CustomNoShowFeeTerms
        this.noShowPolicyTitle = this.gs.restaurantWidgetSettings$.value.CancellationTitle ? this.gs.restaurantWidgetSettings$.value.CancellationTitle : this.ts.instant('noShowPolicy');
      }
      else {
        this.noShowfeeMessage = this.ts.instant('RestaurantCreditCardAssurance');
      }
      this.gs.showPaymentSummary = true;
    }

  }

  @HostListener('window:message', ['$event'])
  onMessage({ origin, data }) {
    if (origin != environment.authorizeIframeResponseOrigin && origin != environment.rGuestPayIframeResponsOrigin) { // set your origin
      return false;
    }
    var rGuestPayRespose = data;
    var payResponse = data;
    if (typeof data != "object") {
      rGuestPayRespose = JSON.parse(data);
    }
    if ((data.type == "txn-completed" && data.transactionInfo && data.transactionInfo.transactionInfo && data.transactionInfo.transactionInfo.payments) || (rGuestPayRespose && (rGuestPayRespose.code || rGuestPayRespose.gatewayResponseData))) {

      if (data.transactionInfo.transactionInfo.successCode == 1 && data.transactionInfo.transactionInfo.payments.length > 0 && data.transactionInfo.transactionInfo.payments[0].paymentType == 7) { //Waiver form
        this.proceedReservation(data.transactionInfo.transactionInfo.payments[0].authorizeTransactionID);
        return;
      }

      if (this.PaymentGateway == PaymentGateways.AuthorizePay) { //Authorize Pay 

        var transInfo = payResponse.transactionInfo.transactionInfo;
        //var cardInfo = transInfo.saleResponse.cardInfo;
        //var gatewayResponseData = transInfo.saleResponse.gatewayResponseData;
        //var transactionReferenceData = transInfo.saleResponse.transactionReferenceData;
        //var transactionResponseData = transInfo.saleResponse.transactionResponseData;

        if (transInfo.errorMessage || transInfo.successCode != 1) {
          if (transInfo.errorMessage) {
            this.gs.setMessageState(transInfo.errorMessage, 0);
          }
          // else if (gatewayResponseData.message) {
          //    gatewayResponseData.message;
          // }
          else {
            this.gs.setMessageState(this.ts.instant("CardInformationProcessNotCompleted"), 0);
          }
        } else if (payResponse && transInfo && transInfo.successCode == 1) {

          var transactions = this.processTransactions(transInfo);
          var dto = {
            RestaurantId: this.gs.restaurantWidgetSettings$.value.RestaurantId,
            PartyId: this.gs.editPartyData$.value?.Id ? this.gs.editPartyData$.value?.Id : null,
            SlotLockIds: this.gs.lockMultipleResult ? this.gs.lockMultipleIds : [this.gs.lockResult.SlotLockIdDTO?.Id],
            BookingID: null,
            TokenType: "",
            PaymentAmount: transInfo.paidAmount,
            PaymentGateway: this.PaymentGateway,
            AuthorizeTransactions: transactions,
            ReservationAttemptId: this.paymentData.ReservationAttemptId,
            ReservationAttemptIds: this.paymentData.Slots?.filter(x => x.ReservationAttemptId > 0).map(x => x.ReservationAttemptId),
            SplitPaymentReload: this.isSplitPayment
          };

          // var callbackDto = this.getPaymentCallbackRequestDTO(cardInfo, transactionReferenceData, transInfo, transactionResponseData, this.paymentData.PaymentGateway);
          this.UpdateReservationAttempt(dto);
        } else {
          this.gs.setMessageState(this.ts.instant("CardInformationProcessNotCompleted"), 0);
        }
      }
      else {
        if (rGuestPayRespose.code && rGuestPayRespose.code != "100") {
          rGuestPayRespose = JSON.parse(data);
          if (rGuestPayRespose.validationErrors && rGuestPayRespose.validationErrors.length > 0) {
            var errorString = "";
            rGuestPayRespose.validationErrors.forEach(function (error, i, arr) {
              errorString = error.fieldName + " " + error.value + "\n";
            })
            this.gs.setMessageState(errorString, 0);
          }
          else if (rGuestPayRespose && rGuestPayRespose.gatewayResponseData && rGuestPayRespose.gatewayResponseData.message) {
            alert(rGuestPayRespose.gatewayResponseData.message);
          }
          else {
            this.gs.setMessageState(this.ts.instant("CardInformationProcessNotCompleted"), 0);
          }
        }
        else if (rGuestPayRespose && rGuestPayRespose.gatewayResponseData && rGuestPayRespose.gatewayResponseData.code == "100") {
          let callbackDto = {
            ReservationAttemptId: this.paymentData.ReservationAttemptId,
            ReservationAttemptIds: this.paymentData.Slots?.filter(x => x.ReservationAttemptId > 0).map(x => x.ReservationAttemptId),
            CardNumber: rGuestPayRespose.cardInfo.accountNumberMasked,
            ExpirationDate: new Date(data.cardInfo.expirationYearMonth.substring(0, 4) + '-' + data.cardInfo.expirationYearMonth.substring(4) + '-01'),
            CVC: "",
            FirstNameHolder: "",
            LastNameHolder: "",
            AddressLine1: "",
            AddressLine2: "",
            City: "",
            State: "",
            PostalCode: "",
            TokenType: "",
            Token: data.token
          };
          this.UpdateReservationAttempt(callbackDto);
        }
        else {
          this.gs.setMessageState(this.ts.instant("CardInformationProcessNotCompleted"), 0);
        }
      }
    }
    else if (data.type == "txn-completed" && data.transactionInfo) {
   
    } else {
      //Show Error Message  
    }
  }

  proceedReservation(waiverFormTrancationId) {
    this.showIframe = false;
    this.waiverFormTrancationId = waiverFormTrancationId;
    if(this.gs.restaurantWidgetSettings$.value.IsCartEnabled){
      this.isUserAllowedToclickConfirm = true;
      this.waiverForm = false;
      if (this.guestDetailsForm.invalid || !this.checkCustomTermsAndMessageOptionValidation()) {
        this.gs.setMessageState(this.ts.instant('completeAllFields'), 0);
      }
      else{
        this.addToButton.disbaledproperity = false;
      }
      
      return;
    }
    //let invoiceId = data.transactionInfo.invoiceID
    //if (this.gs.ispaymentInvolvedInfo && this.gs.ispaymentInvolvedInfo.CreditCardRequired && !this.gs.restaurantWidgetSettings$.value.IsCartEnabled) {
      //this.isUserAllowedToclickConfirm = false;
    if (this.gs.reservationAttemptInfo) {
      if (this.gs.reservationAttemptInfo.ShouldCreditCardBeEntered) {
        if (this.gs.reservationAttemptInfo.CreditCardIFrameURL) {
          this.LoadIframe(this.gs.reservationAttemptInfo.CreditCardIFrameURL)
        }
        else {
          this.gs.setMessageState(this.ts.instant('SorryForPaymentOffline'), 0);
        }
      }
      else {
        this.isUserAllowedToclickConfirm = true;
        if (this.guestDetailsForm.invalid || !this.checkCustomTermsAndMessageOptionValidation()) {
          this.gs.setMessageState(this.ts.instant('completeAllFields'), 0);
          this.showIframe = false;
        }
        else {
          if (!this.gs.restaurantWidgetSettings$.value.IsCartEnabled) {
            this.reservationConfirm();
          } else {
            this.addToButton.disbaledproperity = false;
          }
        }
      }
    } else {
      this.RegisterReservationAttempt(true);
    }

  }


  processTransactions(transInfo) {
    var transactions = transInfo.payments;
    var authorizeTransactions = [];

    if (transactions && transactions.length > 0) {
      transactions.forEach(transaction => {
        if (transaction.successCode == 1) {
          var name = '';
          var paymentDetail = transaction.paymentDetail;
          var roomDetails = {
            RoomNumber: null,
            ConfirmationNumber: null,
            LastName: null
          };
          var pointsDetails = {
            AccountNumber: null,
            BucketName: null,
            Name: null,
            LoyaltyTransactionId: null
          };

          if (transaction.paymentType == 1 || transaction.paymentType == 2) { //credit card
            name = paymentDetail.accountName;
          }

          if (transaction.paymentType == 3) { //Post to room charges
            roomDetails.RoomNumber = paymentDetail.cardIssuer;
            roomDetails.ConfirmationNumber = paymentDetail.cardNumber;
            roomDetails.LastName = paymentDetail.accountName;
            name = paymentDetail.accountName;
          }
          if (transaction.paymentType == 5) { //Loyalty
            pointsDetails.BucketName = paymentDetail.tender;
            pointsDetails.AccountNumber = paymentDetail.cardNumber;
            pointsDetails.Name = paymentDetail.accountName;
            pointsDetails.LoyaltyTransactionId = paymentDetail.followOnData;
            name = paymentDetail.accountName;
          }
          var dto = {
            CardNumber: paymentDetail.cardNumber ? paymentDetail.cardNumber : "",
            ExpirationDate: paymentDetail.expirationDate ? paymentDetail.expirationDate.substring(0, 4) + paymentDetail.expirationDate.substring(4) : "",
            Name: name ? name : "",
            Token: paymentDetail.token ? paymentDetail.token : null,
            TransactionFollowOnData: paymentDetail.followOnData ? paymentDetail.followOnData : null,
            AuthorizeTransactionID: transaction.authorizeTransactionID,
            Amount: transaction.paidAmount,
            PaymentType: transaction.paymentType ? transaction.paymentType : null,
            InvoiceID: transaction.invoiceID ? transaction.invoiceID : null,
            TransactionDate: transaction.transactionsDate ? transaction.transactionsDate : null,
            RoomNumber: roomDetails && roomDetails.RoomNumber ? roomDetails.RoomNumber : null,
            ConfirmationNumber: roomDetails && roomDetails.ConfirmationNumber ? roomDetails.ConfirmationNumber : null,
            BucketName: pointsDetails && pointsDetails.BucketName ? pointsDetails.BucketName : null,
            LoyaltyAccountNumber: pointsDetails && pointsDetails.AccountNumber ? pointsDetails.AccountNumber : null,
            LoyaltyTransactionId: pointsDetails && pointsDetails.LoyaltyTransactionId ? pointsDetails.LoyaltyTransactionId : null,
            IssuerType: pointsDetails &&  paymentDetail.tender ?  paymentDetail.tender : null,
            AuthCode : paymentDetail?.authCode,
            CCType : paymentDetail?.cardIssuerType,
            CCTransactionId : paymentDetail?.payTransactionID,
          };
          authorizeTransactions.push(dto);
        } else if (transaction.errorMessage) {
          this.gs.setMessageState(transaction.errorMessage, 0);
        }
      });
      return authorizeTransactions;
    }
  }

  LoadGuestWaiverForm(formCode) {
    this.gs.GetAuthWaiverForm(this.gs.restaurantWidgetSettings$.value.RestaurantId, formCode).subscribe(data => {
      if (data) {
        this.LoadIframe(data.formURL);
        this.waiverForm = true;
        //if (this.gs.ispaymentInvolvedInfo && this.gs.ispaymentInvolvedInfo.CreditCardRequired) {
          this.RegisterReservationAttempt(false);
        //}
      }
      else {
        this.gs.setMessageState(this.ts.instant('somethingWentWrong'), 0);
      }
    });
  }

  checkCustomTermsAndMessageOptionValidation() {
    let isApproved = true;
    if (this.gs.additionalGuestPage) {
      return true;
    }

    if (this.gs.restaurantWidgetSettings$.value.ConfirmationVia == ConfirmationVia.Both && !this.guestDetailsForm.value.primaryGuest['reservationConfirmationByEmail']
      && !this.guestDetailsForm.value.primaryGuest['reservationConfirmationBySMS']) {
      isApproved = false;
    }
    return isApproved;
  }

  isPartySizeMatchSecondaryContactList(): boolean {
    if (this.gs.operation == operationType.edit && this.gs.editPartyData$.value.SecondaryContacts && this.gs.editPartyData$.value.SecondaryContacts.length > 0 && this.gs.SaveBookingObj.Size < this.components.toArray().length) {
      return false;
    }
    else {
      return true;
    }
  }

  LoadIframe(iframeURl: string) {
    if (iframeURl) {
      this.urlSafe = this.sanitizer.bypassSecurityTrustResourceUrl(iframeURl + "&origin=" + window.location.origin)
      this.showIframe = true;
    }
    else {
      this.gs.setMessageState(this.ts.instant('somethingWentWrong'), 0);
    }
  }

  getPaymentCallbackRequestDTO(cardInfo: any, transactionReferenceData: any, transInfo: any, transactionResponseData: any, paymentGateway: PaymentGateways) {
    let paymentCallbackRequestDTO = {
      RestaurantId: this.gs.restaurantWidgetSettings$.value.RestaurantId,
      ReservationAttemptId: this.paymentData.ReservationAttemptId,
      CardNumber: cardInfo.accountNumberMasked,
      ExpirationDate: cardInfo.expirationYearMonth.substring(0, 4) + '-' + cardInfo.expirationYearMonth.substring(4) + '-01',
      CVC: "",
      FirstNameHolder: "",
      LastNameHolder: "",
      AddressLine1: "",
      AddressLine2: "",
      City: "",
      State: "",
      PostalCode: "",
      TokenType: "",
      Token: transactionReferenceData ? transactionReferenceData.token : null,
      PaymentAmount: transactionResponseData.totalAmount,
      AuthorizeTransactionID: transInfo ? transInfo.authorizeTransactionID : null,
      PaymentType: transInfo ? transInfo.paymentType : null,
      InvoiceID: transInfo ? transInfo.invoiceID : null,
      PaymentGateway: paymentGateway,
      TransactionFollowOnData: transactionReferenceData ? transactionReferenceData.transactionFollowOnData : null,
      TransactionDate: transInfo.transactionsDate,
      IssuerType: transactionReferenceData &&  transactionReferenceData.tender ?  transactionReferenceData.tender : null,
    }
    return paymentCallbackRequestDTO;
  }

  UpdateReservationAttempt(Dto) {
    this.gs.UpdateReservationAttempt(Dto).subscribe(data => {
      this.gs.setMessageState('', 0);
      if (data && (data.ErrorMessage || data.ExceptionMessage || (data.ValidationMessages && data.ValidationMessages.length > 0) || data.length == 0)) {
        if (data.ErrorMessage && data.ErrorMessage.length > 0) {
          var sorrysomethingwentwromg = this.ts.instant('SorryWeGotSomeErrorWhileProcessing');
          var CCUprocessableTryAgainErrorMessage = this.ts.instant('CCUprocessableTryAgainErrorMessage');
          var ImportantErrorMessage = this.ts.instant('ImportantErrorMessage');
          var CreditCardAuthorizationError = this.ts.instant('CreditCardAuthorizationError');
          var TryAgainMessage = this.ts.instant('TryAgainMessage');
          var CardNumbershouldContainOnlyDigits = this.ts.instant('CardNumbershouldContainOnlyDigits');
          var CardNumberShouldConsists13To16Digits = this.ts.instant('CardNumberShouldConsists13To16Digits');
          var CardNumberShouldNotBlank = this.ts.instant('CardNumberShouldNotBlank');
          var SorryWeGotSomeErrorCardExpired = this.ts.instant('SorryWeGotSomeErrorWhileProcessingCardExpired');
          if (data.ErrorMessage == "Please try it one more time, if the problem repeats, contact to rGuestSeat@Agilysys.com")
            var url = sorrysomethingwentwromg + TryAgainMessage;
          else if (data.ErrorMessage == "We're sorry, but we couldn�t process your credit card based on the information you provided. Please try again.")
            var url = sorrysomethingwentwromg + CCUprocessableTryAgainErrorMessage;
          else if (data.ErrorMessage == "[IMPORTANT] Some error happens at the moment of database saving. There is a probability that the payment transaction has performed successfully but this fact hasn't been saved properly. Don't try to do it one more time. Please, contact rGuestSeat@Agilysys.com regarding this error")
            var url = sorrysomethingwentwromg + ImportantErrorMessage;
          else if (data.ErrorMessage == "The provided credit card hasn't been authorized succesfully")
            var url = sorrysomethingwentwromg + CreditCardAuthorizationError;
          else if (data.ErrorMessage.indexOf("The card is expired") > 0)
            var url = SorryWeGotSomeErrorCardExpired;
          else if (data.ErrorMessage == "The card number should consist of only digits")
            var url = sorrysomethingwentwromg + CardNumbershouldContainOnlyDigits;
          else if (data.ErrorMessage == "The card number should consist of from 13 to 16 digits")
            var url = sorrysomethingwentwromg + CardNumberShouldConsists13To16Digits;
          else if (data.ErrorMessage == "The card number shouldn't be blank")
            var url = sorrysomethingwentwromg + CardNumberShouldNotBlank;
          else
            var url = sorrysomethingwentwromg + data.ErrorMessage;
          this.gs.setMessageState(url, 0);
        }
        else {
          var url = sorrysomethingwentwromg + TryAgainMessage;
          this.gs.setMessageState(url, 0);
        }
        this.gs.setMessageState(url, 0);
      } else if (data.RedirectUrl) {
        this.gs.offTimer();
        this.LoadIframe(data.RedirectUrl);
        setTimeout(() => {
          this.gs.setMessageState("Your current payment of " + this.gs.restaurantWidgetSettings$.value.OperationCurrency + Dto.PaymentAmount.toFixed(this.gs.restaurantWidgetSettings$.value.NumberOfFractionalDigits) + " is processed successfully! Please proceed to pay your pending amount " + this.gs.restaurantWidgetSettings$.value.OperationCurrency + data.PendingAmount.toFixed(this.gs.restaurantWidgetSettings$.value.NumberOfFractionalDigits) + " to place your reservation.", 1);
        }, 1);
        //if (!this.isSplitPayment) {
        let timer = moment(data.ExtendedSlotLockResultDTO.ExpiresAt).diff(moment(data.ExtendedSlotLockResultDTO.LockedAt), "seconds");
        this.gs.showTimer = true;
        this.gs.runTimer(timer);
        this.isSplitPayment = true;
        this.gs.isSplitPayment$.next(true);
        //}
      }
      else {
        this.gs.isSplitPayment$.next(false);
        if (this.paymentData.ReservationAttemptId > 0) {
          this.gs.GetRegisterReservationAttempt(this.paymentData.ReservationAttemptId).subscribe(data => {
            if (data && (data.State == PaymentStates.Authorized || data.State == PaymentStates.ChargeCaptured)) {
              this.isUserAllowedToclickConfirm = true;
              if (this.guestDetailsForm.invalid || !this.checkCustomTermsAndMessageOptionValidation()) {
                this.gs.setMessageState(this.ts.instant('completeAllFields'), 0);
                this.showIframe = false;
              }
              else {
                this.reservationConfirm();
              }
            }
            else {
              this.gs.setMessageState(this.ts.instant("CreditCardNotBeProcessed"), 0);
            }
          });
        }
        else {
          const ReservationIds = this.paymentData.Slots?.map(x => x.ReservationAttemptId);
          this.gs.GetRegisterMultipleReservationAttempt(ReservationIds).subscribe(data => {
            if (data) {
              let isAuthorized = true;
              data.forEach(reservationData => {
                // if (reservationData.State !== PaymentStates.Authorized && reservationData.State == PaymentStates.ChargeCaptured ) {
                //   isAuthorized = false;
                // }
                if (reservationData.State != PaymentStates.Authorized && reservationData.State != PaymentStates.ChargeCaptured) {
                  isAuthorized = false;
                }
              });

              if (isAuthorized) {
                this.isUserAllowedToclickConfirm = true;
                if (this.guestDetailsForm.invalid || !this.checkCustomTermsAndMessageOptionValidation()) {
                  this.gs.setMessageState(this.ts.instant('completeAllFields'), 0);
                  this.showIframe = false;
                }
                else {
                  this.reservationConfirm();
                }
              } else {
                this.gs.setMessageState(this.ts.instant("CreditCardNotBeProcessed"), 0);
              }
            }
          });
        }
      }
    });
  }

  createSecondaryContacts() {
    let secondaryContactList = this.buildSecondaryContactList();
    (this.guestDetailsForm as FormGroup).addControl('secondaryContactList', this.fb.array(secondaryContactList.map(contact => this.fb.group(contact))));
    this.gs.CreateSecondaryContacts(this.gs.restaurantWidgetSettings$.value.RestaurantId, this.gs.editPartyData$.value.Id, secondaryContactList).subscribe(data => {
      if (data) {
        this.gs.additionalGuestPage = !this.gs.additionalGuestPage
        this.gs.additionalGuestRequired = 0;
        this.gs.TabChange$.next(ActivityTabs.ConfirmationSummary);
        let partyType = this.gs.selectedSpecialMeal ? this.gs.selectedSpecialMeal.IsForStandbyReservations ? PartyType[2] : PartyType[0] : '';
        this.gs.getByToken(this.gs.editPartyData$.value.Token, '', partyType).subscribe(data => {
          if (data) {
            this.gs.editPartyData$.next(data);
            this.gs.nextButton.next(componentName.confirmDetails);
          }
        })

      }
    });
  }

  buildSecondaryContactList() {
    let secondaryContactList: SecondaryContactDTO[] = [];
    for (let i = 0; i < this.components.length; i++) {
      let secondaryContact = new SecondaryContactDTO();
      if (this.gs.additionalGuestPage || (!this.gs.additionalGuestPage && this.gs.operation == operationType.edit && i != 0)) {
        let FormValue = this.components.toArray()[i].form.value;
        secondaryContact.FirstName = FormValue.firstName;
        secondaryContact.LastName = FormValue.lastName;
        secondaryContact.EmailAddress = FormValue.email;
        secondaryContact.PhoneNumber = FormValue.phone;
        secondaryContact.CountryId = this.components.last.config[2].value;
        secondaryContact.PartyId = this.gs.editPartyData$.value.Id;
        secondaryContact.Notes = this.getCategoryPreferencesNotes(this.components.toArray()[i].form.value);
        secondaryContact.Id = FormValue.id ? FormValue.id : null;
        secondaryContactList.push(secondaryContact)
      }
    }
    return secondaryContactList;
  }

  createPartialReservationforAuth() {
    this.reservationConfirm();
  }

  getFinancialEffectCalculation() {
    let partyDTO = this.buildReservationRequest();
    this.gs.GetFinancialEffectCalculation(partyDTO).subscribe(data => {
      if (data) {
        this.financialData = data;
        if (data.PaymentGateway) {
          this.PaymentGateway = data.PaymentGateway;
        }
        if (data.RefundOption) {
          this.RefundData = data.RefundOption;
        }
        if (data.TotalAmount) {
          this.TotalAmount = data.TotalAmount;
        }
        if (data.RedirectUrl) {
          this.isSplitPayment = false;
          this.isUserAllowedToclickConfirm = false;
          this.paymentData.ReservationAttemptId = data.ReservationAttemptId;
          this.confirmButton.disbaledproperity = true;
          this.LoadIframe(data.RedirectUrl);
        } //else {
        switch (data.PartyPaymentType) {
          case 0: // NotSupported
            this.gs.setMessageState(this.ts.instant("ReservationBetweenLocationPrePaidNotSupported"), 0);
            this.isUserAllowedToclickConfirm = false;
            this.confirmButton.disbaledproperity = true;
            return;
            break;
          case 1: // NoPaymentsInvolved
            // No messaging in this case
            break;
          case 2: // NoEffect
            this.showFinancialEffectPopUp(this.ts.instant('NoChargeOrRefundForThisReservation'));
            break;
          case 3: // NewReservationAttempt
            //paymentIframeRequired = true;
            if (this.isSelectedMealDefferedPayment()) {
              this.popUpMessage = "Your card will be charged prior to your meal time.";
            } else {
              this.popUpMessage = this.ts.instant('NoRefundYourPrePayment') + ' ' + this.gs.restaurantWidgetSettings$.value.OperationCurrency + data.TotalAmount.toFixed(this.gs.restaurantWidgetSettings$.value.NumberOfFractionalDigits);
            }
            this.showFinancialEffectPopUp(this.popUpMessage);
            break;
          case 4: // NoFullRefund
            if (data.TotalAmount != null && (data.TotalAmount > 0)) {
              this.popUpMessage = this.ts.instant('NoRefundYourPrePayment') + ' ' + this.gs.restaurantWidgetSettings$.value.OperationCurrency + data.TotalAmount.toFixed(this.gs.restaurantWidgetSettings$.value.NumberOfFractionalDigits);
            }
            else {
              // There was no prepayment to mention in text (or it was already refunded)
              this.popUpMessage = this.ts.instant('NoChargeOrRefundForThisReservation');
            }
            this.showFinancialEffectPopUp(this.popUpMessage);
            break;
          case 5: // FullRefund
            this.popUpMessage = this.ts.instant('CardUsedForOriginalReservationWillBeRefunded') + ' ' + this.gs.restaurantWidgetSettings$.value.OperationCurrency + data.TotalAmount.toFixed(this.gs.restaurantWidgetSettings$.value.NumberOfFractionalDigits) + ' ' + this.ts.instant('severBusinessDays');
            this.showFinancialEffectPopUp(this.popUpMessage);
            break;
          case 6: // NoFullRefundAndNewReservationAttempt
            if (data.TotalAmount != null && (data.TotalAmount > 0)) {
              this.popUpMessage = this.ts.instant('NoRefundYourPrePayment') + ' ' + this.gs.restaurantWidgetSettings$.value.OperationCurrency + data.PaymentAmount.toFixed(this.gs.restaurantWidgetSettings$.value.NumberOfFractionalDigits);
            }
            else {
              // There was no prepayment to mention in text (or it was already refunded)
              this.popUpMessage = this.ts.instant('noRefundMessage');
            }
            this.showFinancialEffectPopUp(this.popUpMessage);
            break;
          case 7: // FullRefundAndNewReservationAttempt
            this.popUpMessage = this.ts.instant('CardUsedForOriginalReservationWillBeRefunded') + ' ' + this.gs.restaurantWidgetSettings$.value.OperationCurrency + data.TotalAmount.toFixed(this.gs.restaurantWidgetSettings$.value.NumberOfFractionalDigits) + ' ' + this.ts.instant('severBusinessDays');
            this.showFinancialEffectPopUp(this.popUpMessage);
            break;
          case 8: // PartialCharge
            if (this.gs.reservationAttemptInfo.ShouldCreditCardBeEntered) {
              this.popUpMessage = this.ts.instant('CardNeededToUpdateThisReservation') + ' ' + this.gs.restaurantWidgetSettings$.value.OperationCurrency + data.PaymentAmount.toFixed(this.gs.restaurantWidgetSettings$.value.NumberOfFractionalDigits) + ' ' + this.ts.instant('enterCreditCard');
            }
            else {
              this.popUpMessage = this.ts.instant('CardUsedForTheOriginalBookingWillCharged') + ' ' + this.gs.restaurantWidgetSettings$.value.OperationCurrency + data.PaymentAmount.toFixed(this.gs.restaurantWidgetSettings$.value.NumberOfFractionalDigits);
            }
            this.showFinancialEffectPopUp(this.popUpMessage);
            break;
          case 9: // PartialRefund
          case 14:
            if (this.financialData.RefundOption && this.financialData.RefundOption.length > 0) {
              this.popUpMessage = this.ts.instant('Refund request of ') + this.gs.restaurantWidgetSettings$.value.OperationCurrency + data.PaymentAmount.toFixed(this.gs.restaurantWidgetSettings$.value.NumberOfFractionalDigits) + this.ts.instant('hasBeenProcessed');
            } else {
              this.popUpMessage = this.ts.instant('refundMessage') + this.gs.restaurantWidgetSettings$.value.OperationCurrency + Math.abs(data.PaymentAmount) + ".<br />" + this.ts.instant('severalDaysMessage');
            }
            this.showFinancialEffectPopUp(this.popUpMessage);
            break;
          case 10: // NoShowFeeUpdated
            this.popUpMessage = this.ts.instant('IfDonotShowYouWillBeCharged') + ' ' + this.gs.restaurantWidgetSettings$.value.OperationCurrency + data.TotalAmount.toFixed(this.gs.restaurantWidgetSettings$.value.NumberOfFractionalDigits);
            this.showFinancialEffectPopUp(this.popUpMessage);
            break;
          case 11: // Authorize

            if (data.TotalAmount > 0) {
              this.popUpMessage = this.ts.instant('CardUsedAtBookingWillBeChargedAtMealTime') + ' ' + this.gs.restaurantWidgetSettings$.value.OperationCurrency + data.TotalAmount.toFixed(this.gs.restaurantWidgetSettings$.value.NumberOfFractionalDigits);
              this.showFinancialEffectPopUp(this.popUpMessage);
            }
            break;
          case 12: // Authorize updated

            if (data.TotalAmount > 0) {
              this.popUpMessage = this.ts.instant('CardUsedAtBookingWillBeChargedAtMealTime') + ' ' + this.gs.restaurantWidgetSettings$.value.OperationCurrency + data.TotalAmount.toFixed(this.gs.restaurantWidgetSettings$.value.NumberOfFractionalDigits);
              this.showFinancialEffectPopUp(this.popUpMessage);
            }
            break;
        }
        this.bindPaymentAmountAndMessage(data.RatePlanAmount, data.SpecialMealAmount, data.TotalAmount) // need to check how to find deferred payment mode
        if (this.gs.reservationAttemptInfo.ShouldCreditCardBeEntered) {
          this.isUserAllowedToclickConfirm = false;
          this.confirmButton.disbaledproperity = true;
          this.LoadIframe(this.gs.reservationAttemptInfo.CreditCardIFrameURL);
        }
        else {
          if (!data.RedirectUrl) {
            this.isUserAllowedToclickConfirm = true;
            this.confirmButton.disbaledproperity = this.gs.restaurantWidgetSettings$.value.WidgetCustomization.ConfirmationVia == ConfirmationVia.Both;
          }
        }
        // }
      }
    });
  }
  showRefundPopup() {
    const popUpMessage = [{
      dialogTitle: this.ts.instant('paymentInfo'),
    }];
    const componentDetails: ComponentDetails = Utilities.setComponentDetails(PopupMessageComponent, 'small', '', popUpMessage,
      popUpMessage[0].dialogTitle);
    this.financialPopUpRef = this.openCustomPopup(componentDetails, ComponentTypes.financialEffectCalculation, '600px', '700px', true, this.ts.instant('No'), this.ts.instant('Ok'),
     this.ts.instant('cancel'), true)
  }

  openDeleteConfirmationPopUp(index) {
    this.secondaryGuestTobeDeletedIndex = index;
    const popUpMessage = [{
      confirmationMessage: 'Are you sure, would you like to remove this guest from your party ?',
      dialogTitle: this.ts.instant('Remove Secondary Guest'),
      showAlert: true
    }];
    const componentDetails: ComponentDetails = Utilities.setComponentDetails(PopupMessageComponent, 'small', '', popUpMessage,
      popUpMessage[0].dialogTitle);
    this.deleteSecondaryGuestPopUpRef = this.openCustomPopup(componentDetails, ComponentTypes.deleteSecondaryGuest, '450px', '300px', true, '', this.ts.instant('Yes'),
      this.ts.instant('No'), true)
  }

  deleteSecondaryGuestConfirmed() {
    this.guestData.splice(this.secondaryGuestTobeDeletedIndex, 1);
    this.guestData.forEach((data, index) => {
      if (index != 0) {
        this.guestData[index] = { name: this.ts.instant('secondaryGuest') + (index + 1), isNew: this.guestData[index].isNew };
      }
    });
    this.gs.secondaryContactList = this.buildSecondaryContactList();
    this.gs.secondaryContactList.splice((this.secondaryGuestTobeDeletedIndex - 1), 1);
    let data = _.cloneDeep(this.guestData);
    this.guestData = [];
    this.guestData = _.cloneDeep(data);
    setTimeout(() => {
      this.components.toArray().forEach((formData, index) => {
        if (index > 0) {
          this.bindContactsToForm(formData.form, this.gs.secondaryContactList[index - 1]);
        }
      });
      this.gs.secondaryContactList = this.buildSecondaryContactList();
    }, 1);
  }

  showFinancialEffectPopUp(Message: string) {
    const popUpMessage = [{
      confirmationMessage: Message,
      dialogTitle: this.ts.instant('paymentInfo'),
      showAlert: true
    }];
    const componentDetails: ComponentDetails = Utilities.setComponentDetails(PopupMessageComponent, 'small', '', popUpMessage,
      popUpMessage[0].dialogTitle);
    this.financialPopUpRef = this.openCustomPopup(componentDetails, ComponentTypes.financialEffectCalculation, '450px', '300px', true, this.ts.instant('No'), this.ts.instant('Ok'),
     this.ts.instant('cancel'), true)
  }

  showAuthRefundPopup() {
    const popUpMessage = [{
      dialogTitle: this.ts.instant('refundStrategy'),
      popupInput: this.RefundData,
      disabled: true
    }];

    let financialData = {
      FinancialData: this.financialData,
      OperationCurrency: this.gs.restaurantWidgetSettings$.value.OperationCurrency
    }

    const componentDetails: ComponentDetails = Utilities.setComponentDetails(AuthRefundPopupComponent, 'small', '', financialData,
      popUpMessage[0].dialogTitle);
    this.AuthrefundPopupRef = this.openCustomPopup(componentDetails, ComponentTypes.AuthRefundPopup, '650px', '600px', true, '', this.ts.instant('proceed'),
      this.ts.instant('close'), true, '', '', false, true)

  }

  //have to check
  isSelectedMealDefferedPayment(): boolean {
    let isDeffered = false;
    // if (this.gs.reservationFormGroup.get('reservationDetailsForm').get('specialMeal').value) {
    //   isDeffered = (this.gs.reservationFormGroup.get('reservationDetailsForm').get('specialMeal').value.DoesRequirePrepayment && !this.gs.reservationFormGroup.get('reservationDetailsForm').get('specialMeal').value.ChargeOnBooking) ? true : false;
    // }
    return isDeffered;
  }


  backtosummary() {
    this.gs.TabChange$.next(ActivityTabs.ConfirmationSummary)
  }

  bookCart() {
    this.gs.TabChange$.next(ActivityTabs.CartDetails);
  }

  ngOnDestroy() {
    if (this.subscriptions) {
      this.subscriptions.unsubscribe();
    }
  }
}


